(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════
     1. ANNOUNCEMENT BAR ROTATOR
     ═══════════════════════════════════════════════════════ */
  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;

    var slides = bar.querySelectorAll('[data-announcement-slide]');
    if (slides.length < 2) return;

    var prevBtn = bar.querySelector('[data-announcement-prev]');
    var nextBtn = bar.querySelector('[data-announcement-next]');
    var interval = parseInt(bar.dataset.rotateInterval, 10) || 3500;
    var current = 0;
    var total = slides.length;
    var timer;

    function show(idx) {
      slides[current].classList.add('hidden');
      slides[current].style.opacity = '0';
      slides[current].style.transform = 'translateY(-6px)';
      current = ((idx % total) + total) % total;
      slides[current].classList.remove('hidden');
      requestAnimationFrame(function () {
        slides[current].style.transition = 'opacity 0.35s ease, transform 0.35s ease';
        slides[current].style.opacity = '1';
        slides[current].style.transform = 'translateY(0)';
      });
    }

    function startAuto() {
      timer = setInterval(function () { show(current + 1); }, interval);
    }
    function resetAuto() {
      clearInterval(timer);
      startAuto();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); resetAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); resetAuto(); });

    slides.forEach(function (s, i) {
      if (i !== 0) {
        s.classList.add('hidden');
        s.style.opacity = '0';
      }
    });

    startAuto();
  }

  /* ═══════════════════════════════════════════════════════
     2. MOBILE MENU TOGGLE
     ═══════════════════════════════════════════════════════ */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    function closeMenu() {
      toggle.setAttribute('aria-expanded', 'false');
      menu.classList.add('hidden');
    }

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      menu.classList.toggle('hidden');
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  /* ═══════════════════════════════════════════════════════
     3. CAROUSEL ENGINE (reusable)
     ═══════════════════════════════════════════════════════ */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (el) {
      var track = el.querySelector('[data-carousel-track]');
      if (!track) return;

      var slides = track.querySelectorAll('[data-carousel-slide]');
      if (slides.length < 2) return;

      var prevBtn = el.querySelector('[data-carousel-prev]');
      var nextBtn = el.querySelector('[data-carousel-next]');
      var dotsContainer = el.querySelector('[data-carousel-dots]');
      var autoAdvance = el.dataset.carouselAutoplay === 'true';
      var interval = parseInt(el.dataset.carouselInterval, 10) || 5000;
      var current = 0;
      var total = slides.length;
      var timer;
      var startX = 0;
      var isDragging = false;

      function goTo(idx) {
        current = ((idx % total) + total) % total;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';

        if (dotsContainer) {
          dotsContainer.querySelectorAll('[data-carousel-dot]').forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === current);
          });
        }
      }

      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetAuto(); });

      if (dotsContainer) {
        dotsContainer.querySelectorAll('[data-carousel-dot]').forEach(function (dot) {
          dot.addEventListener('click', function () {
            goTo(parseInt(this.dataset.carouselDot, 10));
            resetAuto();
          });
        });
      }

      track.style.display = 'flex';
      track.style.transition = 'transform 0.5s ease';
      slides.forEach(function (s) { s.style.flexShrink = '0'; s.style.width = '100%'; });

      el.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        isDragging = true;
      }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (!isDragging) return;
        isDragging = false;
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) next(); else prev();
          resetAuto();
        }
      }, { passive: true });

      function startAuto() {
        if (autoAdvance) timer = setInterval(next, interval);
      }
      function resetAuto() {
        clearInterval(timer);
        startAuto();
      }
      startAuto();
    });
  }

  /* ═══════════════════════════════════════════════════════
     3b. STALE PDP CACHE REFRESH (Shopify page cache)
     ═══════════════════════════════════════════════════════ */
  function needsGalleryRefresh(gallery) {
    if (!gallery) return false;
    var slideCount = gallery.querySelectorAll('[data-gallery-main]').length;
    if (slideCount <= 1) return false;
    if (!gallery.classList.contains('fz-pdp-gallery')) return true;
    if (gallery.querySelector('[data-gallery-thumbs]') && !gallery.querySelector('[data-gallery-thumbs-col]')) return true;
    if (!gallery.querySelector('[data-gallery-thumbs-col], [data-gallery-thumbs-row]')) return true;
    return false;
  }

  function fetchFreshProductSection(sectionKey) {
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionKey))
      .then(function (res) { return res.json(); })
      .then(function (data) { return data[sectionKey] || ''; });
  }

  function refreshStaleProductSection() {
    return new Promise(function (resolve) {
      var gallery = document.querySelector('[data-product-gallery]');
      if (!needsGalleryRefresh(gallery)) {
        resolve(false);
        return;
      }

      var section = gallery.closest('section[id^="shopify-section-template--"]');
      if (!section) {
        resolve(false);
        return;
      }

      var sectionKey = section.id.replace('shopify-section-', '');
      var prefixMatch = sectionKey.match(/^(template--\d+__)/);
      var prefix = prefixMatch ? prefixMatch[1] : '';
      var keysToTry = [sectionKey];
      if (prefix) {
        keysToTry.push(prefix + 'product_main');
        keysToTry.push(prefix + 'product_gallery_v3');
      }
      keysToTry = keysToTry.filter(function (key, idx) { return keysToTry.indexOf(key) === idx; });

      function tryKey(index) {
        if (index >= keysToTry.length) {
          resolve(false);
          return;
        }
        fetchFreshProductSection(keysToTry[index]).then(function (html) {
          if (!html || html.indexOf('fz-pdp-gallery') === -1) {
            tryKey(index + 1);
            return;
          }

          var tpl = document.createElement('template');
          tpl.innerHTML = html.trim();
          var newSection = tpl.content.querySelector('section') || tpl.content.firstElementChild;
          if (!newSection) {
            tryKey(index + 1);
            return;
          }

          var scripts = Array.prototype.slice.call(tpl.content.querySelectorAll('script'));
          section.replaceWith(newSection);
          scripts.forEach(function (oldScript) {
            var s = document.createElement('script');
            if (oldScript.type) s.type = oldScript.type;
            if (oldScript.src) {
              s.src = oldScript.src;
              if (oldScript.defer) s.defer = true;
            } else {
              s.textContent = oldScript.textContent;
            }
            document.body.appendChild(s);
          });
          resolve(true);
        }).catch(function () { tryKey(index + 1); });
      }

      tryKey(0);
    });
  }

  /* ═══════════════════════════════════════════════════════
     4. PRODUCT GALLERY
     ═══════════════════════════════════════════════════════ */
  function initProductGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var mainSlides = gallery.querySelectorAll('[data-gallery-main][data-index]');
      if (mainSlides.length > 0) return;

      var mainImg = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (!mainImg || thumbs.length === 0) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = this.dataset.galleryThumb;
          var alt = this.getAttribute('alt') || '';
          mainImg.src = src;
          mainImg.alt = alt;

          thumbs.forEach(function (t) { t.classList.remove('ring-2', 'ring-brand-yellow'); });
          this.classList.add('ring-2', 'ring-brand-yellow');
        });
      });
    });
  }

  /* ═══════════════════════════════════════════════════════
     5. ACCORDION (details/summary)
     ═══════════════════════════════════════════════════════ */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-group]').forEach(function (group) {
      var details = group.querySelectorAll('details');
      details.forEach(function (detail) {
        detail.addEventListener('toggle', function () {
          if (this.open) {
            details.forEach(function (other) {
              if (other !== detail && other.open) other.removeAttribute('open');
            });
          }
        });

        var content = detail.querySelector('.accordion-content');
        if (content) {
          var summary = detail.querySelector('summary');
          summary.addEventListener('click', function (e) {
            e.preventDefault();
            if (detail.open) {
              content.style.maxHeight = content.scrollHeight + 'px';
              requestAnimationFrame(function () {
                content.style.maxHeight = '0';
                content.style.opacity = '0';
              });
              setTimeout(function () { detail.removeAttribute('open'); }, 300);
            } else {
              detail.setAttribute('open', '');
              content.style.maxHeight = '0';
              content.style.opacity = '0';
              requestAnimationFrame(function () {
                content.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
                content.style.maxHeight = content.scrollHeight + 'px';
                content.style.opacity = '1';
              });
            }
          });
        }
      });
    });
  }

  /* ═══════════════════════════════════════════════════════
     6. CART DRAWER (AJAX)
     ═══════════════════════════════════════════════════════ */
  var BUNDLE_TIERS = [
    { min: 2, pct: 10 },
    { min: 3, pct: 15 },
    { min: 4, pct: 20 },
    { min: 5, pct: 25 }
  ];

  /* Cart ladder upsells: accessories under $39 — not more beds */
  var CART_ADDON_MAX_CENTS = 3900;
  var CART_COMPLEMENT_MAP = {
    'waterproof-orthopedic-dog-bed': ['snuggle-duck-plush', 'queen-octo-rope-toy', 'self-cleaning-slicker-brush'],
    'paw-print-blanket': ['snuggle-duck-plush', 'queen-octo-rope-toy', 'pet-grooming-mitt'],
    'crunchy-dino-buddy': ['queen-octo-rope-toy', 'snuggle-duck-plush', 'self-cleaning-slicker-brush'],
    'floppy-ear-pup-pal': ['snuggle-duck-plush', 'queen-octo-rope-toy', 'pet-grooming-mitt'],
    'snuggle-duck-plush': ['queen-octo-rope-toy', 'pet-grooming-mitt', 'self-cleaning-slicker-brush'],
    'queen-octo-rope-toy': ['snuggle-duck-plush', 'pet-grooming-mitt', 'self-cleaning-slicker-brush'],
    'pet-grooming-mitt': ['self-cleaning-slicker-brush', 'snuggle-duck-plush', 'queen-octo-rope-toy'],
    'self-cleaning-slicker-brush': ['pet-grooming-mitt', 'snuggle-duck-plush', 'queen-octo-rope-toy']
  };

  var CART_DEFAULT_RECS = [
    'snuggle-duck-plush',
    'queen-octo-rope-toy',
    'pet-grooming-mitt',
    'self-cleaning-slicker-brush',
    'dog-toy-durable-braided-polypropylene-fetch-ball-colorful-interactive-play-toy',
    'pet-nail-clippers-stainless-steel-nail-trimmer-for-dogs-and-cats-ergonomic-design',
    'dog-toy-high-quality-cotton-rope-carrot-shape-durable-chew-toy-for-dental-health',
    'pet-hair-remover-tool-durable-plastic-hair-remover-efficient-versatile-cleaning-solution'
  ];

  function getBundleProgress(itemCount) {
    var current = null;
    var next = BUNDLE_TIERS[0];
    for (var i = 0; i < BUNDLE_TIERS.length; i++) {
      if (itemCount >= BUNDLE_TIERS[i].min) current = BUNDLE_TIERS[i];
      if (itemCount < BUNDLE_TIERS[i].min) {
        next = BUNDLE_TIERS[i];
        break;
      }
      if (i === BUNDLE_TIERS.length - 1) next = null;
    }
    var maxTier = BUNDLE_TIERS[BUNDLE_TIERS.length - 1];
    var progress = Math.min(100, (itemCount / maxTier.min) * 100);
    return { current: current, next: next, progress: progress, max: maxTier.min };
  }

  var CartDrawer = {
    drawer: null,
    overlay: null,
    body: null,
    itemsList: null,
    emptyState: null,
    footer: null,
    countBadges: null,
    subtotalEl: null,
    drawerCountEl: null,
    bundleWrap: null,
    bundleMsg: null,
    bundleBar: null,
    recsWrap: null,
    recsTrack: null,
    recsPrev: null,
    recsNext: null,
    recsToggle: null,
    recsToggleLabel: null,
    recsUserExpanded: true,
    lastRecsItemCount: 0,
    checkoutTotalEl: null,
    recsCache: {},
    recsLoopPeriod: 0,
    addonCatalogPromise: null,

    init: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-drawer-overlay]');
      this.body = document.querySelector('[data-cart-drawer-body]');
      this.itemsList = document.querySelector('[data-cart-items]');
      this.emptyState = document.querySelector('[data-cart-empty]');
      this.footer = document.querySelector('[data-cart-footer]');
      this.countBadges = document.querySelectorAll('[data-cart-count]');
      this.subtotalEl = document.querySelector('[data-cart-subtotal]');
      this.drawerCountEl = document.querySelector('[data-cart-drawer-count]');
      this.bundleWrap = document.querySelector('[data-cart-bundle-wrap]');
      this.bundleMsg = document.querySelector('[data-cart-bundle-msg]');
      this.bundleBar = document.querySelector('[data-cart-bundle-bar]');
      this.recsWrap = document.querySelector('[data-cart-recs-wrap]');
      this.recsTrack = document.querySelector('[data-cart-recs-track]');
      this.recsPrev = document.querySelector('[data-cart-recs-prev]');
      this.recsNext = document.querySelector('[data-cart-recs-next]');
      this.recsToggle = document.querySelector('[data-cart-recs-toggle]');
      this.recsToggleLabel = document.querySelector('[data-cart-recs-toggle-label]');
      this.checkoutTotalEl = document.querySelector('[data-cart-checkout-total]');
      this.checkoutBtn = document.querySelector('[data-cart-checkout]');
      this.discountHint = document.querySelector('[data-cart-discount-hint]');

      if (!this.drawer) return;

      var self = this;

      if (this.recsToggle) {
        this.recsToggle.addEventListener('click', function () {
          var collapsed = self.recsWrap.classList.toggle('is-collapsed');
          self.recsUserExpanded = !collapsed;
          self.recsToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        });
      }

      if (this.recsPrev && this.recsTrack) {
        this.recsPrev.addEventListener('click', function () {
          if (self.recsLoopPeriod > 0 && self.recsTrack.scrollLeft <= 4) {
            // Wrap backwards: jump silently into the duplicate set first
            self.recsTrack.scrollLeft = self.recsTrack.scrollLeft + self.recsLoopPeriod;
          }
          self.recsTrack.scrollBy({ left: -self.recsTrack.clientWidth * 0.82, behavior: 'smooth' });
        });
      }
      if (this.recsNext && this.recsTrack) {
        this.recsNext.addEventListener('click', function () {
          self.recsTrack.scrollBy({ left: self.recsTrack.clientWidth * 0.82, behavior: 'smooth' });
        });
      }
      if (this.recsTrack) {
        this.recsTrack.addEventListener('scroll', function () {
          // Seamless infinite loop: past the first set, jump back one set width
          if (self.recsLoopPeriod > 0 && self.recsTrack.scrollLeft >= self.recsLoopPeriod) {
            self.recsTrack.scrollLeft -= self.recsLoopPeriod;
          }
          self.updateRecsNav();
        }, { passive: true });
      }

      document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });

      document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.close();
        });
      });

      this.drawer.addEventListener('click', function (e) {
        var recAdd = e.target.closest('[data-cart-rec-add]');
        if (recAdd) {
          e.preventDefault();
          var card = recAdd.closest('[data-cart-rec-card]');
          if (!card) return;
          var select = card.querySelector('[data-cart-rec-variant]');
          var variantId = select ? select.value : recAdd.getAttribute('data-variant-id');
          if (!variantId) return;
          recAdd.disabled = true;
          recAdd.textContent = 'Adding…';
          self.addToCart(parseInt(variantId, 10), 1, true).finally(function () {
            recAdd.disabled = false;
            recAdd.textContent = 'Add';
          });
          return;
        }

        var qtyMinus = e.target.closest('[data-cart-qty-minus]');
        var qtyPlus = e.target.closest('[data-cart-qty-plus]');
        var removeBtn = e.target.closest('[data-cart-remove]');

        if (qtyMinus) {
          var item = qtyMinus.closest('[data-cart-item]');
          var key = item ? item.dataset.key : null;
          var val = parseInt(item.querySelector('[data-cart-qty-value]').textContent, 10);
          if (key) self.updateItem(key, Math.max(0, val - 1));
        }
        if (qtyPlus) {
          var item2 = qtyPlus.closest('[data-cart-item]');
          var key2 = item2 ? item2.dataset.key : null;
          var val2 = parseInt(item2.querySelector('[data-cart-qty-value]').textContent, 10);
          if (key2) self.updateItem(key2, val2 + 1);
        }
        if (removeBtn) {
          var item3 = removeBtn.closest('[data-cart-item]');
          var key3 = item3 ? item3.dataset.key : null;
          if (key3) self.updateItem(key3, 0);
        }
      });
    },

    open: function () {
      if (!this.drawer) return;
      this.refreshCart();
      this.drawer.classList.remove('translate-x-full');
      this.overlay.classList.remove('hidden');
      document.body.classList.add('fz-drawer-open');
      requestAnimationFrame(function () {
        document.body.style.overflow = 'hidden';
      });
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.add('translate-x-full');
      this.overlay.classList.add('hidden');
      document.body.classList.remove('fz-drawer-open');
      document.body.style.overflow = '';
    },

    refreshCart: function () {
      var self = this;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.renderCart(cart); });
    },

    renderCart: function (cart) {
      var self = this;

      self.countBadges.forEach(function (el) { el.textContent = cart.item_count; });
      if (self.drawerCountEl) self.drawerCountEl.textContent = cart.item_count;
      if (self.drawer) self.drawer.setAttribute('data-cart-items-n', String(cart.item_count || 0));
      self.renderBundleProgress(cart.item_count);
      self.syncRecsCollapse(cart.item_count);

      // Bundle discount display. Shopify's automatic discounts already apply in
      // cart.js (total_price is net), so prefer the REAL applied amount; only
      // fall back to an estimate if the discount hasn't been applied yet.
      var subtotalPre = cart.items_subtotal_price || cart.total_price;
      var actualDiscount = Math.max(0, subtotalPre - cart.total_price);
      var bundleState = getBundleProgress(cart.item_count);
      var discountPct = bundleState.current ? bundleState.current.pct : 0;
      var discountCents = actualDiscount;
      var discountIsEstimate = false;
      if (!discountCents && discountPct > 0) {
        discountCents = Math.round(subtotalPre * discountPct / 100);
        discountIsEstimate = true;
      }
      if (!discountPct && discountCents > 0 && subtotalPre > 0) {
        discountPct = Math.round((discountCents / subtotalPre) * 100);
      }
      var netTotal = discountIsEstimate ? (subtotalPre - discountCents) : cart.total_price;

      if (self.subtotalEl) self.subtotalEl.textContent = self.formatMoney(subtotalPre);
      if (self.checkoutTotalEl) self.checkoutTotalEl.textContent = self.formatMoney(cart.total_price);
      self.updateCheckoutLink();

      var discRow = document.querySelector('[data-cart-discount-row]');
      if (discRow) {
        if (discountCents > 0 && cart.item_count > 0) {
          discRow.hidden = false;
          var lbl = discRow.querySelector('[data-cart-discount-label]');
          var amt = discRow.querySelector('[data-cart-discount-amt]');
          var est = discRow.querySelector('[data-cart-estimated-total]');
          var totalLbl = discRow.querySelector('[data-cart-total-label]');
          if (lbl) lbl.textContent = '-' + discountPct + '% EXTRA OFF';
          if (amt) amt.textContent = '- ' + self.formatMoney(discountCents);
          if (est) est.textContent = self.formatMoney(netTotal);
          if (totalLbl) totalLbl.textContent = discountIsEstimate ? 'Estimated total' : 'Total';
        } else {
          discRow.hidden = true;
        }
      }

      if (cart.item_count === 0) {
        if (self.emptyState) self.emptyState.style.display = '';
        if (self.itemsList) self.itemsList.style.display = 'none';
        if (self.footer) self.footer.style.display = 'none';
        if (self.bundleWrap) self.bundleWrap.hidden = true;
        if (self.recsWrap) self.recsWrap.hidden = true;
        return;
      }

      if (self.emptyState) self.emptyState.style.display = 'none';
      if (self.footer) self.footer.style.display = '';
      if (!self.itemsList) return;
      self.itemsList.style.display = '';

      var html = '';
      cart.items.forEach(function (item) {
        var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        html += '<li class="flex gap-4 px-5 py-4" data-cart-item data-key="' + self.escapeHtml(item.key) + '">' +
          '<a href="' + item.url + '" class="flex-shrink-0">' +
            '<img src="' + self.getSizedImage(item.image, '120x') + '" alt="' + self.escapeHtml(item.title) + '" class="w-20 h-20 object-cover rounded-lg" width="80" height="80" loading="lazy">' +
          '</a>' +
          '<div class="flex-1 min-w-0">' +
            '<a href="' + item.url + '" class="block font-heading font-semibold text-sm text-brand-ink truncate hover:text-brand-yellow transition-colors">' + self.escapeHtml(item.product_title) + '</a>' +
            (variantTitle ? '<p class="text-xs text-gray-400 mt-0.5">' + self.escapeHtml(variantTitle) + '</p>' : '') +
            '<p class="text-sm font-semibold text-brand-ink mt-1">' + self.formatMoney(item.price) + '</p>' +
            '<div class="flex items-center justify-between mt-2">' +
              '<div class="inline-flex items-center border border-gray-200 rounded-full">' +
                '<button class="w-7 h-7 flex items-center justify-center text-gray-500 hover:text-brand-ink transition-colors" data-cart-qty-minus aria-label="Decrease quantity">' +
                  '<svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" d="M5 12h14"/></svg>' +
                '</button>' +
                '<span class="w-8 text-center text-sm font-medium" data-cart-qty-value>' + item.quantity + '</span>' +
                '<button class="w-7 h-7 flex items-center justify-center text-gray-500 hover:text-brand-ink transition-colors" data-cart-qty-plus aria-label="Increase quantity">' +
                  '<svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" d="M12 5v14M5 12h14"/></svg>' +
                '</button>' +
              '</div>' +
              '<button class="text-gray-400 hover:text-red-500 transition-colors p-1" data-cart-remove aria-label="Remove ' + self.escapeHtml(item.product_title) + '">' +
                '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>' +
              '</button>' +
            '</div>' +
            '<p class="text-xs text-gray-400 mt-1">Line total: <span class="font-medium text-brand-ink" data-cart-line-total>' + self.formatMoney(item.line_price) + '</span></p>' +
            (function () {
              var origLine = item.original_line_price || (item.price * item.quantity);
              var itemSaving = Math.max(0, origLine - item.line_price);
              if (!itemSaving && discountPct > 0) itemSaving = Math.round(origLine * discountPct / 100);
              if (!itemSaving || !discountPct) return '';
              return '<span class="fz-cart-item-off"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>-' + discountPct + '% EXTRA OFF (\u2212' + self.formatMoney(itemSaving) + ')</span>';
            })() +
          '</div>' +
        '</li>';
      });

      self.itemsList.innerHTML = html;
      self.loadRecommendations(cart);
    },

    renderBundleProgress: function (itemCount) {
      if (!this.bundleWrap || !this.bundleMsg || !this.bundleBar) return;
      if (!itemCount) {
        this.bundleWrap.hidden = true;
        return;
      }
      this.bundleWrap.hidden = false;
      var state = getBundleProgress(itemCount);
      var msg = '';
      if (state.current && !state.next) {
        msg = '<span>Maximum savings unlocked!</span> Extra ' + state.current.pct + '% off applies automatically at checkout.';
      } else if (state.next) {
        var need = state.next.min - itemCount;
        if (itemCount === 1) {
          msg = 'Add <span>' + need + ' more item</span> to unlock <span>' + state.next.pct + '% off</span> at checkout.';
        } else if (state.current) {
          msg = 'Nice: <span>' + state.current.pct + '% off</span> unlocked. Add <span>' + need + ' more</span> for <span>' + state.next.pct + '% off</span> at checkout.';
        } else {
          msg = 'Add <span>' + need + ' more item' + (need === 1 ? '' : 's') + '</span> to unlock an extra ' + state.next.pct + '% off at checkout.';
        }
      }
      this.bundleMsg.innerHTML = msg;
      this.bundleBar.style.width = state.progress + '%';
      document.querySelectorAll('[data-cart-bundle-tier]').forEach(function (el) {
        var tierMin = parseInt(el.getAttribute('data-cart-bundle-tier'), 10);
        var unlocked = itemCount >= tierMin;
        el.classList.toggle('is-unlocked', unlocked);
      });
    },

    updateRecsNav: function () {
      if (!this.recsTrack || !this.recsPrev || !this.recsNext) return;
      if (this.recsLoopPeriod > 0) {
        // Infinite loop: both directions always available
        this.recsPrev.disabled = false;
        this.recsNext.disabled = false;
        return;
      }
      var track = this.recsTrack;
      this.recsPrev.disabled = track.scrollLeft <= 4;
      this.recsNext.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    },

    // With 3+ lines, offer a collapse toggle so cart items stay scrollable
    // (phones + laptop/desktop). Keep expanded by default; reset when count changes.
    syncRecsCollapse: function (itemCount) {
      if (!this.recsWrap) return;
      var n = itemCount || 0;
      var shouldOfferToggle = n >= 3;

      if (n !== this.lastRecsItemCount) {
        this.recsUserExpanded = true;
        this.lastRecsItemCount = n;
      }

      this.recsWrap.classList.toggle('has-collapse-toggle', shouldOfferToggle);

      if (!this.recsToggle) return;

      if (!shouldOfferToggle) {
        this.recsToggle.hidden = true;
        this.recsWrap.classList.remove('is-collapsed');
        this.recsToggle.setAttribute('aria-expanded', 'true');
        return;
      }

      this.recsToggle.hidden = false;
      var collapsed = !this.recsUserExpanded;
      this.recsWrap.classList.toggle('is-collapsed', collapsed);
      this.recsToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');

      var state = getBundleProgress(n);
      var label = 'Add more to save';
      if (state.next) {
        var need = state.next.min - n;
        label = 'Add ' + need + ' more · unlock ' + state.next.pct + '% off';
      } else if (state.current) {
        label = 'Add more to save';
      }
      if (this.recsToggleLabel) this.recsToggleLabel.textContent = label;
    },

    // Duplicate the rendered card set so horizontal scrolling loops forever.
    setupRecsLoop: function () {
      var track = this.recsTrack;
      this.recsLoopPeriod = 0;
      if (!track) return;
      var originals = Array.prototype.slice.call(track.children);
      if (originals.length < 3) return;
      originals.forEach(function (el) {
        var clone = el.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      var period = track.children[originals.length].offsetLeft - track.children[0].offsetLeft;
      if (period > 0) this.recsLoopPeriod = period;
    },

    getCartProductIds: function (cart) {
      var ids = [];
      var handles = [];
      cart.items.forEach(function (item) {
        if (item.product_id) ids.push(String(item.product_id));
        var handle = item.handle || '';
        if (!handle && item.url) {
          var match = item.url.match(/\/products\/([^/?]+)/);
          if (match) handle = match[1];
        }
        if (handle && handles.indexOf(handle) === -1) handles.push(handle);
      });
      return { ids: ids, handles: handles };
    },

    fetchProductByHandle: function (handle) {
      if (this.recsCache[handle]) {
        return Promise.resolve(this.recsCache[handle]);
      }
      var self = this;
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          self.recsCache[handle] = p;
          return p;
        })
        .catch(function () { return null; });
    },

    fetchComplementary: function (productId) {
      return fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=complementary', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) { return (data && data.products) ? data.products : []; })
        .catch(function () { return []; });
    },

    fetchRelated: function (productId) {
      return fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) { return (data && data.products) ? data.products : []; })
        .catch(function () { return []; });
    },

    hasClaimedWelcomeOffer: function () {
      try {
        return localStorage.getItem('fz_offer_subscribed_v2') === '1';
      } catch (e) {
        return false;
      }
    },

    updateCheckoutLink: function () {
      if (!this.checkoutBtn) this.checkoutBtn = document.querySelector('[data-cart-checkout]');
      if (!this.discountHint) this.discountHint = document.querySelector('[data-cart-discount-hint]');
      var claimed = this.hasClaimedWelcomeOffer();
      if (this.checkoutBtn) {
        this.checkoutBtn.setAttribute('href', claimed ? '/checkout?discount=WELCOME10' : '/checkout');
      }
      if (this.discountHint) {
        // Only show when welcome code is claimed — otherwise the footer stays lean.
        if (claimed) {
          this.discountHint.hidden = false;
          this.discountHint.innerHTML = '<strong>WELCOME10</strong> applies at checkout.';
        } else {
          this.discountHint.hidden = true;
          this.discountHint.textContent = '';
        }
      }
    },

    parseRecPriceCents: function (value) {
      if (value == null || value === '') return null;
      var n = typeof value === 'string' ? parseFloat(value) : Number(value);
      if (isNaN(n)) return null;
      // Collection JSON uses dollars; product.js / recommendations use cents.
      if (n > 0 && n < 1000) return Math.round(n * 100);
      return Math.round(n);
    },

    minRecPriceCents: function (p) {
      var self = this;
      var min = Infinity;
      (p.variants || []).forEach(function (v) {
        if (v.available === false) return;
        var c = self.parseRecPriceCents(v.price);
        if (c != null && c < min) min = c;
      });
      if (min !== Infinity) return min;
      var fallback = self.parseRecPriceCents(p.price_min != null ? p.price_min : p.price);
      return fallback != null ? fallback : Infinity;
    },

    isCartBedProduct: function (p) {
      var tags = Array.isArray(p.tags) ? p.tags.join(' ') : (p.tags || '');
      var t = ((p.title || '') + ' ' + (p.product_type || p.type || '') + ' ' + tags).toLowerCase();
      if (/blanket|throw|toy|chew|plush|groom|brush|clean|mitt|clipper|pad|scoop/.test(t)) {
        // Allow soft goods / accessories even if title mentions "bed" in SEO noise.
        if (!/\bdog bed\b|\bpet bed\b|orthopedic|mattress|sofa bed|donut bed|cave bed/.test(t)) return false;
      }
      return /\bdog bed\b|\bpet bed\b|orthopedic|mattress|sofa bed|donut bed|cave bed|\bbed\b/.test(t);
    },

    isExcludedCartAddon: function (p) {
      var tags = Array.isArray(p.tags) ? p.tags.join(' ') : (p.tags || '');
      var t = ((p.title || '') + ' ' + (p.product_type || p.type || '') + ' ' + tags).toLowerCase();
      return /harness|leash|collar|carrier|stroller|tactical|car seat|booster/.test(t);
    },

    isUnder39Addon: function (p) {
      if (!p) return false;
      if (this.isCartBedProduct(p)) return false;
      if (this.isExcludedCartAddon(p)) return false;
      var min = this.minRecPriceCents(p);
      return min <= CART_ADDON_MAX_CENTS;
    },

    normalizeCollectionAddon: function (raw) {
      var self = this;
      var variants = (raw.variants || []).map(function (v) {
        return {
          id: v.id,
          title: v.title,
          available: v.available !== false,
          price: self.parseRecPriceCents(v.price) || 0,
          compare_at_price: self.parseRecPriceCents(v.compare_at_price),
          option1: v.option1,
          option2: v.option2,
          option3: v.option3,
          featured_image: v.featured_image
        };
      });
      var featured = raw.featured_image;
      if (featured && typeof featured === 'object') featured = featured.src;
      var images = (raw.images || []).map(function (img) {
        return typeof img === 'string' ? img : (img && img.src) || '';
      }).filter(Boolean);
      if (!featured && images[0]) featured = images[0];
      return {
        id: raw.id,
        handle: raw.handle,
        title: raw.title,
        product_type: raw.product_type || raw.type || '',
        tags: raw.tags || [],
        url: raw.url || ('/products/' + raw.handle),
        featured_image: featured,
        images: images,
        variants: variants,
        available: !!raw.available || variants.some(function (v) { return v.available; })
      };
    },

    fetchAddonCatalog: function () {
      var self = this;
      if (self.addonCatalogPromise) return self.addonCatalogPromise;
      function fetchColl(handle) {
        return fetch('/collections/' + handle + '/products.json?limit=250', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (data) { return data.products || []; })
          .catch(function () { return []; });
      }
      self.addonCatalogPromise = Promise.all([
        fetchColl('toys-enrichment'),
        fetchColl('cleaning-kit')
      ]).then(function (results) {
        var list = [];
        (results[0] || []).concat(results[1] || []).forEach(function (raw) {
          var p = self.normalizeCollectionAddon(raw);
          if (self.isUnder39Addon(p) && p.available) list.push(p);
        });
        return list;
      });
      return self.addonCatalogPromise;
    },

    buildRecHandles: function (cart) {
      var cartMeta = this.getCartProductIds(cart);
      var handles = [];
      var seen = {};
      cartMeta.handles.forEach(function (h) { seen[h] = true; });

      cartMeta.handles.forEach(function (h) {
        var complements = CART_COMPLEMENT_MAP[h] || [];
        complements.forEach(function (ch) {
          if (!seen[ch] && handles.indexOf(ch) === -1) handles.push(ch);
        });
      });

      CART_DEFAULT_RECS.forEach(function (h) {
        if (!seen[h] && handles.indexOf(h) === -1) handles.push(h);
      });

      return handles.slice(0, 16);
    },

    loadRecommendations: function (cart) {
      var self = this;
      if (!self.recsWrap || !self.recsTrack) return;

      var cartMeta = self.getCartProductIds(cart);
      var excludeIds = {};
      var excludeHandles = {};
      cartMeta.ids.forEach(function (id) { excludeIds[id] = true; });
      cartMeta.handles.forEach(function (h) { excludeHandles[h] = true; });

      var apiPromise = cartMeta.ids.length > 0
        ? self.fetchComplementary(cartMeta.ids[0]).then(function (products) {
            if (products.length > 0) return products;
            return self.fetchComplementary(cartMeta.ids[cartMeta.ids.length - 1]);
          })
        : Promise.resolve([]);

      var relatedPromise = cartMeta.ids.length > 0
        ? self.fetchRelated(cartMeta.ids[0])
        : Promise.resolve([]);
      var handles = self.buildRecHandles(cart);
      var handlesPromise = Promise.all(handles.map(function (h) { return self.fetchProductByHandle(h); }));
      var catalogPromise = self.fetchAddonCatalog();

      Promise.all([apiPromise, relatedPromise, handlesPromise, catalogPromise]).then(function (results) {
        var seenIds = {};
        var list = [];

        function pushProduct(p, allowDegrade) {
          if (!p || !p.id || excludeIds[String(p.id)] || seenIds[String(p.id)]) return;
          if (p.handle && excludeHandles[p.handle]) return;
          var available = p.available;
          if (p.variants && p.variants.length) {
            available = p.variants.some(function (v) { return v.available; });
          }
          if (!available) return;
          if (!allowDegrade && !self.isUnder39Addon(p)) return;
          if (allowDegrade && self.isCartBedProduct(p)) return;
          if (allowDegrade && self.minRecPriceCents(p) > CART_ADDON_MAX_CENTS) return;
          // Recommendations API may return dollar strings — normalize variant prices to cents.
          if (p.variants && p.variants.length) {
            p.variants = p.variants.map(function (v) {
              var copy = Object.assign({}, v);
              copy.price = self.parseRecPriceCents(v.price) || 0;
              if (v.compare_at_price != null) {
                copy.compare_at_price = self.parseRecPriceCents(v.compare_at_price);
              }
              return copy;
            });
          }
          seenIds[String(p.id)] = true;
          list.push(p);
        }

        // Prefer curated / complement handles first, then catalog, then API.
        (results[2] || []).forEach(function (p) { pushProduct(p, false); });
        (results[3] || []).forEach(function (p) { pushProduct(p, false); });
        (results[0] || []).forEach(function (p) { pushProduct(p, false); });
        (results[1] || []).forEach(function (p) { pushProduct(p, false); });

        // Graceful degrade: still under $39, still not beds — from related/API only.
        if (list.length < 3) {
          (results[0] || []).concat(results[1] || []).forEach(function (p) {
            pushProduct(p, true);
          });
        }

        // Sort cheapest first so the ladder strip leads with affordable picks.
        list.sort(function (a, b) {
          return self.minRecPriceCents(a) - self.minRecPriceCents(b);
        });

        self.renderRecommendations(list.slice(0, 12));
      });
    },

    renderRecommendations: function (products) {
      var self = this;
      if (!self.recsWrap || !self.recsTrack) return;

      if (!products || products.length === 0) {
        self.recsWrap.hidden = true;
        self.recsTrack.innerHTML = '';
        self.recsLoopPeriod = 0;
        return;
      }

      self.recsWrap.hidden = false;
      var html = '';

      products.forEach(function (product) {
        var img = '';
        if (product.featured_image) img = product.featured_image;
        else if (product.images && product.images[0]) img = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;

        var variant = null;
        if (product.variants && product.variants.length) {
          for (var i = 0; i < product.variants.length; i++) {
            if (product.variants[i].available) { variant = product.variants[i]; break; }
          }
          if (!variant) variant = product.variants[0];
        }
        if (!variant) return;

        var priceHtml = self.formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var recPct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          priceHtml = '<s>' + self.formatMoney(variant.compare_at_price) + '</s>' + priceHtml +
            '<span style="display:inline-block;margin-left:5px;padding:1px 6px;border-radius:9999px;background:rgba(34,197,94,.12);color:#15803d;font-size:.75em;font-weight:700">-' + recPct + '%</span>';
        }

        var variantSelect = '';
        var hasVariantSelect = product.variants.length > 1;
        if (hasVariantSelect) {
          variantSelect = '<select class="fz-cart-rec__variant" data-cart-rec-variant aria-label="Choose variant">';
          product.variants.forEach(function (v) {
            if (!v.available) return;
            variantSelect += '<option value="' + v.id + '">' + self.escapeHtml(v.title) + '</option>';
          });
          variantSelect += '</select>';
        }

        var productUrl = product.url || (product.handle ? '/products/' + product.handle : '');
        var imgHtml = '<img class="fz-cart-rec__img" src="' + self.getSizedImage(img, '120x') + '" alt="' + self.escapeHtml(product.title) + '" width="64" height="64" loading="lazy">';
        var nameHtml = self.escapeHtml(product.title);
        if (productUrl) {
          var safeUrl = self.escapeHtml(productUrl);
          imgHtml = '<a class="fz-cart-rec__media" href="' + safeUrl + '">' + imgHtml + '</a>';
          nameHtml = '<a class="fz-cart-rec__name" href="' + safeUrl + '">' + nameHtml + '</a>';
        } else {
          nameHtml = '<p class="fz-cart-rec__name">' + nameHtml + '</p>';
        }

        html += '<article class="fz-cart-rec__card' + (hasVariantSelect ? ' has-variant' : '') + '" data-cart-rec-card>' +
          imgHtml +
          '<div class="fz-cart-rec__body">' +
            nameHtml +
            '<p class="fz-cart-rec__price">' + priceHtml + '</p>' +
            '<div class="fz-cart-rec__actions">' +
              variantSelect +
              '<button type="button" class="fz-cart-rec__add" data-cart-rec-add data-variant-id="' + variant.id + '">ADD</button>' +
            '</div>' +
          '</div>' +
        '</article>';
      });

      self.recsTrack.innerHTML = html;
      self.recsTrack.scrollLeft = 0;
      self.recsLoopPeriod = 0;
      requestAnimationFrame(function () {
        self.setupRecsLoop();
        self.updateRecsNav();
      });
    },

    updateItem: function (key, qty) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.renderCart(cart); });
    },

    addToCart: function (variantId, qty, skipOpen) {
      return this.addItems([{ id: variantId, quantity: qty || 1 }], skipOpen);
    },

    addItems: function (items, skipOpen, opts) {
      var self = this;
      opts = opts || {};
      if (!items || !items.length) return Promise.resolve();
      // Multiple lines = main product + PDP "Complete the cozy" picks (or similar stack).
      // Don't re-prompt with the post-ATC upsell sheet in that case.
      var stackedWithExtras = items.length > 1;
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          self.renderCart(cart);
          if (stackedWithExtras && window.FurzzeeFBT && typeof window.FurzzeeFBT.clearSelected === 'function') {
            window.FurzzeeFBT.clearSelected();
          }
          var showComplete = !skipOpen && !opts.skipComplete && !stackedWithExtras &&
            window.FurzzeeCompleteOrder && typeof window.FurzzeeCompleteOrder.offer === 'function';
          if (showComplete) {
            return window.FurzzeeCompleteOrder.offer(cart, { skipOpen: !!skipOpen });
          }
          if (!skipOpen) self.open();
          else {
            self.drawer.classList.remove('translate-x-full');
            self.overlay.classList.remove('hidden');
          }
          return cart;
        });
    },

    formatMoney: function (cents) {
      return '$' + (cents / 100).toFixed(2);
    },

    escapeHtml: function (str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    },

    getSizedImage: function (url, size) {
      if (!url) return '';
      return url.replace(/(\.[^.]+)$/, '_' + size + '$1');
    }
  };

  /* ═══════════════════════════════════════════════════════
     6b. STICKY ADD TO CART BAR (product pages)
     ═══════════════════════════════════════════════════════ */
  function initStickyAtc() {
    var bar = document.querySelector('[data-fz-sticky-atc]');
    var mainBtn = document.querySelector('[data-add-to-cart-btn]');
    var form = document.querySelector('[data-add-to-cart]');
    if (!bar || !mainBtn || !form) return;

    var stickyBtn = bar.querySelector('[data-fz-sticky-atc-btn]');
    var stickyPrice = bar.querySelector('[data-fz-sticky-price]');
    var stickyVariant = bar.querySelector('[data-fz-sticky-variant]');
    var stickyImg = bar.querySelector('[data-fz-sticky-img]');
    var stickyQty = bar.querySelector('[data-fz-sticky-qty]');
    var qtyMinus = bar.querySelector('[data-fz-sticky-qty-minus]');
    var qtyPlus = bar.querySelector('[data-fz-sticky-qty-plus]');
    var variantInput = form.querySelector('[data-variant-id]');

    function setVisible(show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('fz-has-sticky-atc', show);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        setVisible(!entries[0].isIntersecting);
      }, { threshold: 0, rootMargin: '0px' });
      observer.observe(mainBtn);
    } else {
      window.addEventListener('scroll', function () {
        var rect = mainBtn.getBoundingClientRect();
        setVisible(rect.bottom < 0 || rect.top > window.innerHeight);
      }, { passive: true });
    }

    document.addEventListener('fz:variant-updated', function (e) {
      var d = e.detail || {};
      if (stickyPrice && d.price) {
        if (d.comparePrice && d.savePct) {
          stickyPrice.innerHTML = '<s class="fz-sticky-atc__was"></s>' + '<span></span>' + '<span class="fz-sticky-atc__pct">-' + d.savePct + '%</span>';
          stickyPrice.querySelector('s').textContent = d.comparePrice;
          stickyPrice.querySelector('span').textContent = d.price;
        } else {
          stickyPrice.textContent = d.price;
        }
      }
      if (stickyVariant) {
        if (d.variantTitle) {
          stickyVariant.textContent = d.variantTitle;
          stickyVariant.hidden = false;
        } else {
          stickyVariant.hidden = true;
        }
      }
      if (stickyImg && d.image) stickyImg.src = d.image;
      if (stickyBtn) {
        stickyBtn.disabled = !d.available;
        stickyBtn.textContent = d.available ? 'Add to Cart' : 'Sold Out';
      }
    });

    if (qtyMinus && stickyQty) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(stickyQty.value, 10) || 1;
        if (val > 1) stickyQty.value = String(val - 1);
        var mainQty = document.querySelector('[data-pdp-qty-input]');
        if (mainQty) mainQty.value = stickyQty.value;
      });
    }
    if (qtyPlus && stickyQty) {
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(stickyQty.value, 10) || 1;
        stickyQty.value = String(Math.min(99, val + 1));
        var mainQty = document.querySelector('[data-pdp-qty-input]');
        if (mainQty) mainQty.value = stickyQty.value;
      });
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.disabled || !variantInput) return;
        var qty = parseInt(stickyQty && stickyQty.value, 10) || 1;
        var vid = parseInt(variantInput.value, 10);
        if (!vid) return;

        var items = [{ id: vid, quantity: qty }];
        if (window.FurzzeeFBT && typeof window.FurzzeeFBT.getSelectedItems === 'function') {
          var extras = window.FurzzeeFBT.getSelectedItems();
          if (extras && extras.length) items = items.concat(extras);
        }

        var originalText = stickyBtn.textContent;
        stickyBtn.disabled = true;
        stickyBtn.textContent = 'Adding…';

        CartDrawer.addItems(items).finally(function () {
          stickyBtn.textContent = 'Added!';
          setTimeout(function () {
            stickyBtn.textContent = originalText;
            stickyBtn.disabled = false;
          }, 1500);
        });
      });
    }
  }

  /* ═══════════════════════════════════════════════════════
     6c. FREQUENTLY BOUGHT TOGETHER (Stack & Save)
     Curated: 2 under-$39 toys/cleaning + 1 bed/mat
     Preview modal · size pills · refresh
     ═══════════════════════════════════════════════════════ */
  var FurzzeeFBT = {
    root: null,
    list: null,
    totalEl: null,
    refreshBtn: null,
    preview: null,
    productId: null,
    mainPrice: 0,
    addonPool: [],
    bedPool: [],
    products: [],
    selectedByIndex: {},
    page: 0,
    previewProduct: null,
    previewSelected: {},
    previewImgIdx: 0,
    previewRowIndex: null,
    ADDON_MAX_CENTS: 3900,
    ADDON_SLOTS: 2,
    productCache: {},

    init: function () {
      this.root = document.querySelector('[data-fz-fbt]');
      if (!this.root) return;
      this.list = this.root.querySelector('[data-fz-fbt-list]');
      this.totalEl = this.root.querySelector('[data-fz-fbt-total]');
      this.refreshBtn = this.root.querySelector('[data-fz-fbt-refresh]');
      this.picksEl = this.root.querySelector('[data-fz-fbt-picks]');
      this.summaryEl = this.root.querySelector('[data-fz-fbt-summary]');
      this.statusEl = this.root.querySelector('[data-fz-fbt-status]');
      this.countEl = this.root.querySelector('[data-fz-fbt-count]');
      this.chipEl = this.root.querySelector('[data-fz-fbt-chip]');
      this.ladderFill = this.root.querySelector('[data-fz-fbt-ladder-fill]');
      this.tierEls = this.root.querySelectorAll('[data-fz-fbt-tier]');
      this.preview = document.querySelector('[data-fz-fbt-preview]');
      this.mainPrice = parseInt(this.root.getAttribute('data-main-price'), 10) || 0;
      this.productId = this.root.getAttribute('data-product-id');
      this.mode = this.root.getAttribute('data-mode') || 'full';
      this.anchor = this.root.getAttribute('data-anchor') || 'other';
      this.anchorNoun = this.root.getAttribute('data-anchor-noun') || 'one';
      this.species = this.root.getAttribute('data-species') || 'any';
      if (!this.productId) return;

      var self = this;
      document.addEventListener('fz:variant-updated', function (e) {
        if (e.detail && typeof e.detail.priceCents === 'number') {
          self.mainPrice = e.detail.priceCents;
        } else {
          var priceEl = document.querySelector('[data-product-price]');
          if (priceEl) {
            var raw = (priceEl.textContent || '').replace(/[^0-9.]/g, '');
            var dollars = parseFloat(raw);
            if (!isNaN(dollars)) self.mainPrice = Math.round(dollars * 100);
          }
        }
        self.updateTotal();
      });

      if (this.refreshBtn) {
        this.refreshBtn.addEventListener('click', function () { self.refresh(); });
      }

      // PDP quantity counts toward the ladder (qty 2 of this item already unlocks 10%).
      var qtyInput = document.querySelector('[data-pdp-qty-input]');
      if (qtyInput) {
        qtyInput.addEventListener('input', function () { self.updateTotal(); });
        qtyInput.addEventListener('change', function () { self.updateTotal(); });
      }
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('[data-pdp-qty-plus],[data-pdp-qty-minus]')) {
          setTimeout(function () { self.updateTotal(); }, 0);
        }
      });

      // Paint the ladder immediately so the savings disclosure never waits on product fetches.
      this.updateTotal();

      if (this.preview) {
        this.preview.querySelectorAll('[data-fz-fbt-pv-close]').forEach(function (el) {
          el.addEventListener('click', function () { self.closePreview(); });
        });
        var prev = this.preview.querySelector('[data-fz-fbt-pv-prev]');
        var next = this.preview.querySelector('[data-fz-fbt-pv-next]');
        if (prev) prev.addEventListener('click', function () { self.shiftPreviewImage(-1); });
        if (next) next.addEventListener('click', function () { self.shiftPreviewImage(1); });
        var atc = this.preview.querySelector('[data-fz-fbt-pv-atc]');
        var stack = this.preview.querySelector('[data-fz-fbt-pv-stack]');
        if (atc) atc.addEventListener('click', function () { self.previewAddToCart(); });
        if (stack) stack.addEventListener('click', function () { self.previewAddToStack(); });
        window.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.preview.classList.contains('is-open')) self.closePreview();
        });
      }

      this.load();
    },

    formatMoney: function (cents) {
      return '$' + (Number(cents) / 100).toFixed(2);
    },

    textBlob: function (p) {
      return ((p.product_type || p.type || '') + ' ' + (p.title || '') + ' ' + (p.handle || '') + ' ' + (p.tags || []).join(' ')).toLowerCase();
    },

    isAvailable: function (p) {
      if (!p || !p.variants || !p.variants.length) return false;
      return p.variants.some(function (v) { return v.available !== false; });
    },

    minPrice: function (p) {
      var min = Infinity;
      (p.variants || []).forEach(function (v) {
        if (v.available === false) return;
        var c = Number(v.price);
        if (c < min) min = c;
      });
      return min === Infinity ? 0 : min;
    },

    parseMoneyToCents: function (value) {
      if (value == null || value === '') return null;
      if (typeof value === 'string') return Math.round(parseFloat(value) * 100);
      var n = Number(value);
      if (isNaN(n)) return null;
      // Collection JSON sometimes yields dollar numbers; .js / recommendations use cents.
      if (n > 0 && n < 1000) return Math.round(n * 100);
      return Math.round(n);
    },

    /* ── Pairing engine ────────────────────────────────────────────
       Anchor = the PDP product. Picks = cheap complements a shopper adds
       next to it: grooming/cleaning ("care"), toys, and blankets/mats
       ("comfort"). Never another high-ticket bed. Roles by anchor: */
    ROLE_ORDER: {
      bed:   ['care', 'toy', 'comfort'],
      toy:   ['toy', 'care', 'comfort'],
      care:  ['care', 'toy', 'comfort'],
      other: ['toy', 'care', 'comfort']
    },
    /* Caps are in the shop's base currency (USD). Storefront prices arrive in the
       visitor's presentment currency (e.g. CAD ×1.43), so caps scale by Shopify.currency.rate. */
    ROLE_CAP_CENTS: { toy: 3999, care: 3999, comfort: 4999 },
    fxRate: function () {
      try {
        var r = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
        return (r > 0 && isFinite(r)) ? r : 1;
      } catch (e) { return 1; }
    },
    capFor: function (role) {
      return Math.round((this.ROLE_CAP_CENTS[role] || 0) * this.fxRate());
    },
    ROLE_LABEL: { toy: 'Toy', care: 'Grooming', comfort: 'Comfort' },
    ROLE_PHRASE: { toy: 'a toy', care: 'a grooming pick', comfort: 'a blanket or mat' },

    isExcludedAddon: function (p) {
      var t = this.textBlob(p);
      return /harness|leash|collar|carrier|stroller|backpack|vest for|tactical|car seat|booster|seat belt|seat cover|trunk|crate|repell|deterrent|bark|fence|training|camera|monitor|aquarium|bird|jacket|raincoat|apparel|couch cover|sofa protector|screen door|pool|steps|stairs|vacuum|dryer|scratch|perch|hammock|window|litter/.test(t);
    },

    roleOf: function (p) {
      if (this.isExcludedAddon(p)) return null;
      var t = this.textBlob(p);
      // Toys first: tags such as "easy to clean" must not turn a toy into a grooming pick.
      if (/toy|chew|plush|rope|squeak|fetch|puzzle|snuffle|tug|enrich|lick mat|slow feeder|treat/.test(t)) return 'toy';
      if (/groom|brush|glove|mitt|hair remover|lint|deshed|deodor|odor|purif|nail|wipe|shampoo|paw cleaner|paw washer|self.cleaning/.test(t)) return 'care';
      if (/heating pad|warming|blanket|cooling|ice silk|\bmats?\b|cushion|pillow|throw/.test(t)) return 'comfort';
      return null;
    },

    speciesOk: function (p) {
      if (this.species !== 'dog' && this.species !== 'cat') return true;
      var t = ' ' + this.textBlob(p).replace(/[-|,]/g, ' ') + ' ';
      var isCat = /\scats?\s|kitten|feline/.test(t);
      var isDog = /\sdogs?\s|pupp|canine/.test(t);
      if (this.species === 'dog') return !(isCat && !isDog);
      return !(isDog && !isCat);
    },

    rankRole: function (list) {
      var self = this;
      return (list || []).slice().sort(function (a, b) {
        var d = (b._fromRec ? 1 : 0) - (a._fromRec ? 1 : 0);
        if (d) return d;
        d = (self.isBestSellerTagged(b) ? 1 : 0) - (self.isBestSellerTagged(a) ? 1 : 0);
        if (d) return d;
        return self.minPrice(a) - self.minPrice(b);
      });
    },

    isBedMat: function (p) {
      if (p._pool === 'beds') return true;
      var t = this.textBlob(p);
      return /bed|mat|blanket|mattress|orthopedic|cooling|sofa|cushion|donut|car seat/.test(t);
    },

    isBestSellerTagged: function (p) {
      var t = ((p.tags || []).join(' ') + ' ' + (p.handle || '') + ' ' + (p.title || '')).toLowerCase();
      return /best.?sell|bestseller|customer.?favou?rite|top.?pick|popular/.test(t);
    },

    rankBedPool: function (list) {
      var self = this;
      return (list || []).slice().sort(function (a, b) {
        var aRec = a._fromRec ? 1 : 0;
        var bRec = b._fromRec ? 1 : 0;
        if (aRec !== bRec) return bRec - aRec;
        var aBs = self.isBestSellerTagged(a) ? 1 : 0;
        var bBs = self.isBestSellerTagged(b) ? 1 : 0;
        if (aBs !== bBs) return bBs - aBs;
        return 0;
      });
    },

    normalizeCollectionProduct: function (raw, pool) {
      var self = this;
      var variants = (raw.variants || []).map(function (v) {
        return {
          id: v.id,
          title: v.title,
          available: v.available !== false,
          price: self.parseMoneyToCents(v.price) || 0,
          compare_at_price: self.parseMoneyToCents(v.compare_at_price),
          option1: v.option1,
          option2: v.option2,
          option3: v.option3,
          featured_image: v.featured_image
        };
      });

      var images = (raw.images || []).map(function (img) {
        return typeof img === 'string' ? img : (img.src || '');
      }).filter(Boolean);

      var featured = raw.featured_image;
      if (featured && typeof featured === 'object') featured = featured.src;
      if (!featured && images[0]) featured = images[0];

      var options = raw.options || [];
      if (options.length && typeof options[0] === 'object') {
        options = options.map(function (o) { return o.name || o; });
      }

      return {
        id: raw.id,
        handle: raw.handle,
        title: raw.title,
        product_type: raw.product_type || raw.type || '',
        tags: raw.tags || [],
        url: raw.url || ('/products/' + raw.handle),
        featured_image: featured,
        images: images,
        options: options,
        variants: variants,
        _pool: pool || ''
      };
    },

    normalizeRecProduct: function (raw) {
      var images = [];
      if (raw.images && raw.images.length) {
        images = raw.images.map(function (img) {
          return typeof img === 'string' ? img : (img.src || '');
        }).filter(Boolean);
      }
      var featured = raw.featured_image;
      if (featured && typeof featured === 'object') featured = featured.src;
      var options = raw.options || [];
      if (options.length && typeof options[0] === 'object') {
        options = options.map(function (o) { return o.name || o; });
      }
      return {
        id: raw.id,
        handle: raw.handle,
        title: raw.title,
        product_type: raw.type || raw.product_type || '',
        tags: raw.tags || [],
        url: raw.url || ('/products/' + raw.handle),
        featured_image: featured,
        images: images,
        options: options,
        variants: (raw.variants || []).map(function (v) {
          return {
            id: v.id,
            title: v.title,
            available: v.available !== false,
            price: Number(v.price),
            compare_at_price: v.compare_at_price ? Number(v.compare_at_price) : null,
            option1: v.option1,
            option2: v.option2,
            option3: v.option3,
            featured_image: v.featured_image
          };
        }),
        description: raw.description || '',
        _pool: ''
      };
    },

    fetchCollection: function (handle, pool) {
      var self = this;
      return fetch('/collections/' + handle + '/products.json?limit=50', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          return (data.products || []).map(function (p) {
            return self.normalizeCollectionProduct(p, pool);
          });
        })
        .catch(function () { return []; });
    },

    dedupe: function (list) {
      var seen = {};
      return (list || []).filter(function (p) {
        if (!p || seen[String(p.id)]) return false;
        seen[String(p.id)] = true;
        return true;
      });
    },

    load: function () {
      var self = this;
      Promise.all([
        this.fetchCollection('toys-enrichment', 'toys'),
        this.fetchCollection('cleaning-kit', 'cleaning'),
        this.fetchCollection('beds-blankets', 'beds'),
        CartDrawer.fetchComplementary(this.productId),
        CartDrawer.fetchRelated(this.productId)
      ]).then(function (results) {
        var pool = { toy: [], care: [], comfort: [] };
        var seen = {};
        function consider(p, fromRec) {
          if (!p || String(p.id) === String(self.productId) || seen[String(p.id)]) return;
          if (!self.isAvailable(p) || !self.speciesOk(p)) return;
          var role = self.roleOf(p);
          if (!role) return;
          if (self.minPrice(p) > self.capFor(role)) return;
          seen[String(p.id)] = true;
          p._role = role;
          if (fromRec) p._fromRec = true;
          pool[role].push(p);
        }
        // Shopify recommendations first so they outrank catalogue fill.
        ;[results[3], results[4]].forEach(function (arr) {
          (arr || []).forEach(function (raw) { consider(self.normalizeRecProduct(raw), true); });
        });
        (results[0] || []).concat(results[1] || [], results[2] || []).forEach(function (p) { consider(p, false); });

        Object.keys(pool).forEach(function (k) { pool[k] = self.rankRole(pool[k]); });
        self.pool = pool;

        if (!pool.toy.length && !pool.care.length && !pool.comfort.length) {
          self.hidePicks();
          return;
        }
        self.page = 0;
        self.applyPage();
        self.showPicks();
      });
    },

    poolSize: function () {
      var pool = this.pool || {};
      return (pool.toy || []).length + (pool.care || []).length + (pool.comfort || []).length;
    },

    pickSet: function () {
      var self = this;
      var order = this.ROLE_ORDER[this.anchor] || this.ROLE_ORDER.other;
      var pool = this.pool || { toy: [], care: [], comfort: [] };
      var picked = [];
      var used = {};
      var SLOTS = 3;

      // One pick per role in priority order; Refresh rotates each role's list.
      order.forEach(function (role) {
        var list = pool[role] || [];
        if (!list.length || picked.length >= SLOTS) return;
        var start = self.page % list.length;
        for (var i = 0; i < list.length; i++) {
          var p = list[(start + i) % list.length];
          if (used[String(p.id)]) continue;
          used[String(p.id)] = true;
          picked.push(p);
          break;
        }
      });

      // Fill any empty slot from the highest-priority roles that still have items.
      for (var r = 0; r < order.length && picked.length < SLOTS; r++) {
        var list2 = pool[order[r]] || [];
        var start2 = list2.length ? (this.page + 1) % list2.length : 0;
        for (var j = 0; j < list2.length && picked.length < SLOTS; j++) {
          var q = list2[(start2 + j) % list2.length];
          if (used[String(q.id)]) continue;
          used[String(q.id)] = true;
          picked.push(q);
        }
      }
      return picked;
    },

    applyPage: function () {
      this.products = this.pickSet();
      this.selectedByIndex = {};
      var self = this;
      this.products.forEach(function (p, i) {
        var v = null;
        for (var n = 0; n < p.variants.length; n++) {
          if (p.variants[n].available !== false) { v = p.variants[n]; break; }
        }
        self.selectedByIndex[i] = v || p.variants[0];
      });
      this.render();
    },

    refresh: function () {
      if (!this.poolSize()) return;
      var self = this;
      if (this.refreshBtn) {
        this.refreshBtn.classList.add('is-spinning');
        setTimeout(function () { self.refreshBtn.classList.remove('is-spinning'); }, 550);
      }
      this.page += 1;
      this.applyPage();
    },

    imageUrl: function (product, variant, size) {
      var url = '';
      if (variant && variant.featured_image) {
        url = typeof variant.featured_image === 'string'
          ? variant.featured_image
          : (variant.featured_image.src || '');
      }
      if (!url && product.featured_image) url = product.featured_image;
      if (!url && product.images && product.images[0]) url = product.images[0];
      size = size || '160x160';
      return CartDrawer.getSizedImage(url, size) || url;
    },

    optionValues: function (product, pos) {
      var values = [];
      (product.variants || []).forEach(function (v) {
        var val = v['option' + pos];
        if (val && values.indexOf(val) === -1) values.push(val);
      });
      return values;
    },

    findVariantForOptions: function (product, selected) {
      return (product.variants || []).find(function (v) {
        for (var i = 1; i <= (product.options || []).length; i++) {
          if (selected[i] && v['option' + i] !== selected[i]) return false;
        }
        return true;
      }) || null;
    },

    priceHtml: function (variant) {
      if (!variant) return '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        return '<s>' + this.formatMoney(variant.compare_at_price) + '</s>' + this.formatMoney(variant.price);
      }
      return this.formatMoney(variant.price);
    },

    sizeButtonsHtml: function (product, index, current) {
      var options = product.options || [];
      var sizePos = 0;
      for (var i = 0; i < options.length; i++) {
        if (/size|kind|pack|pcs|dimension/i.test(String(options[i]))) {
          sizePos = i + 1;
          break;
        }
      }
      // No size-like option (colours, styles): keep the row quiet. Show the preselected
      // option as one line that opens the preview to change it.
      if (!sizePos) {
        if ((product.variants || []).length > 1) {
          var curLabel = current && current.title && current.title !== 'Default Title' ? current.title : '';
          return '<button type="button" class="fz-fbt__more" data-fz-fbt-preview-btn data-index="' + index + '">' +
            (curLabel ? CartDrawer.escapeHtml(curLabel) + ' · Change' : 'Choose option') + '</button>';
        }
        return '';
      }
      var values = this.optionValues(product, sizePos);
      if (values.length <= 1) {
        if ((product.variants || []).length > 1 || (options.length > 1)) {
          return '<button type="button" class="fz-fbt__more" data-fz-fbt-preview-btn data-index="' + index + '">Choose option</button>';
        }
        return '';
      }

      if (values.length > 8 || options.length > 1) {
        return '<button type="button" class="fz-fbt__more" data-fz-fbt-preview-btn data-index="' + index + '">Choose size</button>';
      }

      var html = '<div class="fz-fbt__sizes" data-fz-fbt-sizes data-index="' + index + '" data-pos="' + sizePos + '">';
      values.forEach(function (val) {
        var match = (product.variants || []).find(function (v) {
          return v['option' + sizePos] === val && v.available !== false;
        });
        var any = (product.variants || []).find(function (v) { return v['option' + sizePos] === val; });
        var target = match || any;
        if (!target) return;
        var pressed = current && current['option' + sizePos] === val;
        var unavailable = !match;
        html += '<button type="button" class="fz-fbt__size' + (unavailable ? ' is-unavailable' : '') + '" data-value="' +
          CartDrawer.escapeHtml(val) + '" data-variant-id="' + target.id + '" data-price="' + target.price + '" aria-pressed="' +
          (pressed ? 'true' : 'false') + '"' + (unavailable ? ' disabled' : '') + '>' + CartDrawer.escapeHtml(val) + '</button>';
      });
      html += '</div>';
      return html;
    },

    render: function () {
      var self = this;
      if (!this.list) return;
      if (!this.products.length) {
        this.list.innerHTML = '<p class="fz-fbt__loading">No pairings right now — try Refresh.</p>';
        return;
      }

      var html = '';
      this.products.forEach(function (product, index) {
        var current = self.selectedByIndex[index] || product.variants[0];
        var img = self.imageUrl(product, current);
        var isBed = false;
        var badge = self.isBestSellerTagged(product)
          ? '<span class="fz-fbt__badge fz-fbt__badge--hot">Best seller</span>'
          : '<span class="fz-fbt__badge">' + (self.ROLE_LABEL[product._role] || 'Pairs well') + '</span>';

        html +=
          '<div class="fz-fbt__row' + (isBed ? ' is-bed' : '') + '">' +
            '<input type="checkbox" class="fz-fbt__check" data-fz-fbt-check data-index="' + index + '" data-variant-id="' + current.id + '" data-price="' + current.price + '">' +
            '<button type="button" class="fz-fbt__thumb-wrap" data-fz-fbt-preview-btn data-index="' + index + '" aria-label="Preview ' + CartDrawer.escapeHtml(product.title) + '">' +
              '<img class="fz-fbt__thumb" data-fz-fbt-thumb data-index="' + index + '" src="' + CartDrawer.escapeHtml(img) + '" alt="" width="64" height="64" loading="lazy">' +
              '<span class="fz-fbt__preview-cue">Preview</span>' +
            '</button>' +
            '<div class="fz-fbt__meta">' +
              badge +
              '<div class="fz-fbt__top">' +
                '<button type="button" class="fz-fbt__name" data-fz-fbt-preview-btn data-index="' + index + '">' + CartDrawer.escapeHtml(product.title) + '</button>' +
                '<span class="fz-fbt__price" data-fz-fbt-price data-index="' + index + '">' + self.priceHtml(current) + '</span>' +
              '</div>' +
              self.sizeButtonsHtml(product, index, current) +
            '</div>' +
          '</div>';
      });

      this.list.innerHTML = html;
      this.bindRowEvents();
      this.updateTotal();
    },

    bindRowEvents: function () {
      var self = this;
      this.list.querySelectorAll('[data-fz-fbt-check]').forEach(function (cb) {
        cb.addEventListener('change', function () { self.updateTotal(); });
      });
      this.list.querySelectorAll('[data-fz-fbt-preview-btn]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.openPreview(parseInt(btn.getAttribute('data-index'), 10));
        });
      });
      this.list.querySelectorAll('.fz-fbt__size').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var wrap = btn.closest('[data-fz-fbt-sizes]');
          var idx = parseInt(wrap.getAttribute('data-index'), 10);
          wrap.querySelectorAll('.fz-fbt__size').forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
          var product = self.products[idx];
          var variant = (product.variants || []).find(function (v) { return v.id === vid; });
          if (variant) self.selectedByIndex[idx] = variant;
          var check = self.list.querySelector('[data-fz-fbt-check][data-index="' + idx + '"]');
          if (check) {
            check.setAttribute('data-variant-id', String(vid));
            check.setAttribute('data-price', btn.getAttribute('data-price') || '0');
            check.checked = true;
          }
          var priceEl = self.list.querySelector('[data-fz-fbt-price][data-index="' + idx + '"]');
          if (priceEl && variant) priceEl.innerHTML = self.priceHtml(variant);
          var thumb = self.list.querySelector('[data-fz-fbt-thumb][data-index="' + idx + '"]');
          if (thumb && variant) thumb.src = self.imageUrl(product, variant);
          self.updateTotal();
        });
      });
    },

    fetchFullProduct: function (handle) {
      if (this.productCache[handle]) return Promise.resolve(this.productCache[handle]);
      var self = this;
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var normalized = self.normalizeRecProduct(p);
          normalized.description = p.description || '';
          self.productCache[handle] = normalized;
          return normalized;
        });
    },

    openPreview: function (index) {
      var self = this;
      var rowProduct = this.products[index];
      if (!rowProduct || !this.preview) return;
      this.previewRowIndex = index;

      this.fetchFullProduct(rowProduct.handle).then(function (product) {
        product._role = rowProduct._role;
        self.previewProduct = product;
        self.previewImgIdx = 0;
        self.previewSelected = {};

        var current = self.selectedByIndex[index];
        (product.options || []).forEach(function (opt, i) {
          var pos = i + 1;
          self.previewSelected[pos] = (current && current['option' + pos]) || (product.variants[0] && product.variants[0]['option' + pos]);
        });

        self.preview.querySelector('[data-fz-fbt-pv-title]').textContent = product.title;
        var desc = self.preview.querySelector('[data-fz-fbt-pv-desc]');
        if (desc) {
          desc.innerHTML = self.formatPreviewDescription(product.description || '');
        }

        self.renderPreviewThumbs();
        self.renderPreviewOptions();
        self.syncPreviewVariant();
        self.preview.classList.add('is-open');
        self.preview.setAttribute('aria-hidden', 'false');
        document.body.classList.add('fz-fbt-preview-open');
        document.body.style.overflow = 'hidden';
        var scroll = self.preview.querySelector('.fz-fbt-pv__scroll');
        if (scroll) scroll.scrollTop = 0;
      }).catch(function () { /* ignore */ });
    },

    formatPreviewDescription: function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html || '';
      // Drop scripts/styles/images from quick-view copy
      tmp.querySelectorAll('script,style,noscript,iframe,img,svg,video').forEach(function (el) {
        el.remove();
      });
      var text = (tmp.textContent || '').replace(/\u00a0/g, ' ').replace(/[ \t]+/g, ' ').trim();
      if (!text) return '<p>No description available for this item.</p>';
      // Prefer real paragraphs when present
      var paras = Array.prototype.slice.call(tmp.querySelectorAll('p'))
        .map(function (p) { return (p.textContent || '').replace(/\s+/g, ' ').trim(); })
        .filter(Boolean);
      if (paras.length >= 1) {
        return paras.slice(0, 8).map(function (p) {
          return '<p>' + CartDrawer.escapeHtml(p) + '</p>';
        }).join('');
      }
      // Fall back to sentence/line chunks so long paste-ups stay readable
      var chunks = text.split(/\n+/).map(function (s) { return s.trim(); }).filter(Boolean);
      if (chunks.length <= 1 && text.length > 320) {
        chunks = text.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [text];
        chunks = chunks.map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 8);
      }
      return chunks.slice(0, 8).map(function (p) {
        return '<p>' + CartDrawer.escapeHtml(p) + '</p>';
      }).join('');
    },

    renderPreviewThumbs: function () {
      var self = this;
      var product = this.previewProduct;
      var thumbs = this.preview.querySelector('[data-fz-fbt-pv-thumbs]');
      var images = product.images && product.images.length ? product.images : [product.featured_image].filter(Boolean);
      product._previewImages = images;
      thumbs.innerHTML = images.map(function (src, i) {
        return '<button type="button" class="fz-fbt-pv__thumb' + (i === self.previewImgIdx ? ' is-active' : '') + '" data-img-idx="' + i + '">' +
          '<img src="' + CartDrawer.escapeHtml(CartDrawer.getSizedImage(src, '120x120') || src) + '" alt="" loading="lazy">' +
          '</button>';
      }).join('');
      thumbs.querySelectorAll('[data-img-idx]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.previewImgIdx = parseInt(btn.getAttribute('data-img-idx'), 10);
          self.updatePreviewImage();
        });
      });
      this.updatePreviewImage();
    },

    updatePreviewImage: function () {
      var images = (this.previewProduct && this.previewProduct._previewImages) || [];
      if (!images.length) return;
      if (this.previewImgIdx < 0) this.previewImgIdx = images.length - 1;
      if (this.previewImgIdx >= images.length) this.previewImgIdx = 0;
      var src = images[this.previewImgIdx];
      var img = this.preview.querySelector('[data-fz-fbt-pv-img]');
      img.src = src + (src.indexOf('?') === -1 ? '?width=1200' : '&width=1200');
      img.alt = this.previewProduct.title;
      this.preview.querySelector('[data-fz-fbt-pv-counter]').textContent =
        (this.previewImgIdx + 1) + ' / ' + images.length;
      var self = this;
      this.preview.querySelectorAll('.fz-fbt-pv__thumb').forEach(function (t, i) {
        t.classList.toggle('is-active', i === self.previewImgIdx);
      });
    },

    shiftPreviewImage: function (delta) {
      this.previewImgIdx += delta;
      this.updatePreviewImage();
    },

    renderPreviewOptions: function () {
      var self = this;
      var product = this.previewProduct;
      var wrap = this.preview.querySelector('[data-fz-fbt-pv-options]');
      if (!product.options || !product.options.length ||
          (product.variants.length === 1 && product.variants[0].title === 'Default Title')) {
        wrap.innerHTML = '';
        return;
      }
      var html = '';
      product.options.forEach(function (optName, idx) {
        var pos = idx + 1;
        var values = self.optionValues(product, pos);
        html += '<div class="fz-fbt-pv__group" data-fz-fbt-pv-group data-pos="' + pos + '">' +
          '<p class="fz-fbt-pv__opt-label">' + CartDrawer.escapeHtml(String(optName)) +
          ': <strong data-fz-fbt-pv-selected>' + CartDrawer.escapeHtml(self.previewSelected[pos] || '') + '</strong></p>' +
          '<div class="fz-fbt-pv__values">';
        values.forEach(function (val) {
          var available = (product.variants || []).some(function (v) {
            return v['option' + pos] === val && v.available !== false;
          });
          var pressed = self.previewSelected[pos] === val;
          html += '<button type="button" class="fz-fbt-pv__val' + (!available ? ' is-unavailable' : '') +
            '" data-pos="' + pos + '" data-value="' + CartDrawer.escapeHtml(val) + '" aria-pressed="' +
            (pressed ? 'true' : 'false') + '"' + (!available ? ' disabled' : '') + '>' +
            CartDrawer.escapeHtml(val) + '</button>';
        });
        html += '</div></div>';
      });
      wrap.innerHTML = html;
      wrap.querySelectorAll('.fz-fbt-pv__val').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var pos = btn.getAttribute('data-pos');
          self.previewSelected[pos] = btn.getAttribute('data-value');
          var group = btn.closest('[data-fz-fbt-pv-group]');
          group.querySelectorAll('.fz-fbt-pv__val').forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          var label = group.querySelector('[data-fz-fbt-pv-selected]');
          if (label) label.textContent = btn.getAttribute('data-value');
          self.syncPreviewVariant();
        });
      });
    },

    syncPreviewVariant: function () {
      var v = this.findVariantForOptions(this.previewProduct, this.previewSelected);
      var priceEl = this.preview.querySelector('[data-fz-fbt-pv-price]');
      var atc = this.preview.querySelector('[data-fz-fbt-pv-atc]');
      if (!v) {
        atc.disabled = true;
        atc.textContent = 'Unavailable';
        return;
      }
      priceEl.innerHTML = this.priceHtml(v);
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      if (v.featured_image) {
        var src = typeof v.featured_image === 'string' ? v.featured_image : v.featured_image.src;
        var images = this.previewProduct._previewImages || [];
        var idx = -1;
        for (var i = 0; i < images.length; i++) {
          if (!images[i] || !src) continue;
          if (images[i].split('?')[0] === src.split('?')[0]) { idx = i; break; }
        }
        if (idx >= 0) {
          this.previewImgIdx = idx;
          this.updatePreviewImage();
        }
      }
    },

    previewCurrentVariant: function () {
      return this.findVariantForOptions(this.previewProduct, this.previewSelected);
    },

    previewAddToCart: function () {
      var v = this.previewCurrentVariant();
      if (!v || !v.available) return;
      var self = this;
      var atc = this.preview.querySelector('[data-fz-fbt-pv-atc]');
      atc.disabled = true;
      atc.textContent = 'Adding…';
      CartDrawer.addToCart(v.id, 1).then(function () {
        self.closePreview();
        atc.disabled = false;
        atc.textContent = 'Add to Cart';
      });
    },

    previewAddToStack: function () {
      var v = this.previewCurrentVariant();
      if (!v || this.previewRowIndex == null) return;
      var idx = this.previewRowIndex;
      var rowProduct = this.products[idx];
      var match = rowProduct && (rowProduct.variants || []).find(function (rv) {
        return String(rv.id) === String(v.id);
      });
      this.selectedByIndex[idx] = match || {
        id: v.id,
        title: v.title,
        available: v.available,
        price: v.price,
        compare_at_price: v.compare_at_price,
        option1: v.option1,
        option2: v.option2,
        option3: v.option3,
        featured_image: v.featured_image
      };
      this.render();
      var check = this.list.querySelector('[data-fz-fbt-check][data-index="' + idx + '"]');
      if (check) {
        check.checked = true;
        check.setAttribute('data-variant-id', String(v.id));
        check.setAttribute('data-price', String(v.price));
      }
      this.updateTotal();
      this.closePreview();
    },

    closePreview: function () {
      if (!this.preview) return;
      this.preview.classList.remove('is-open');
      this.preview.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('fz-fbt-preview-open');
      var drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer || drawer.classList.contains('translate-x-full')) {
        document.body.style.overflow = '';
      }
    },

    getSelectedItems: function () {
      if (!this.list) return [];
      var items = [];
      this.list.querySelectorAll('[data-fz-fbt-check]:checked').forEach(function (cb) {
        var id = parseInt(cb.getAttribute('data-variant-id'), 10);
        if (id) items.push({ id: id, quantity: 1 });
      });
      return items;
    },

    clearSelected: function () {
      if (!this.list) return;
      this.list.querySelectorAll('[data-fz-fbt-check]:checked').forEach(function (cb) {
        cb.checked = false;
      });
      this.updateTotal();
    },

    hidePicks: function () {
      if (this.picksEl) this.picksEl.hidden = true;
      if (this.refreshBtn) this.refreshBtn.hidden = true;
      this.root.hidden = false;
      this.updateTotal();
    },

    showPicks: function () {
      if (this.picksEl) this.picksEl.hidden = false;
      if (this.refreshBtn) this.refreshBtn.hidden = false;
      this.root.hidden = false;
    },

    mainQty: function () {
      var input = document.querySelector('[data-pdp-qty-input]');
      var q = input ? parseInt(input.value, 10) : 1;
      if (!q || q < 1) q = 1;
      if (q > 99) q = 99;
      return q;
    },

    /* Dynamic copy: names what is on offer next to this anchor, e.g.
       "Add a grooming pick or a toy with this bed and 10% comes off everything at checkout." */
    pairingSentence: function (pct) {
      var self = this;
      var roles = [];
      (this.products || []).forEach(function (p) {
        if (p._role && roles.indexOf(p._role) === -1) roles.push(p._role);
      });
      var phrases = roles.map(function (r) {
        if (r === self.anchor && r === 'toy') return 'another toy';
        if (r === self.anchor && r === 'care') return 'another grooming pick';
        return self.ROLE_PHRASE[r];
      }).filter(Boolean).slice(0, 2);
      var what = phrases.length ? phrases.join(' or ') : 'one more item';
      return 'Add ' + what + ' with this ' + this.anchorNoun + ' and <span>' + pct + '% comes off everything</span> at checkout.';
    },

    renderLadder: function (count) {
      var state = getBundleProgress(count);
      if (this.ladderFill) this.ladderFill.style.width = Math.max(8, state.progress) + '%';
      if (this.tierEls && this.tierEls.length) {
        var nextMin = state.next ? state.next.min : null;
        this.tierEls.forEach(function (el) {
          var min = parseInt(el.getAttribute('data-fz-fbt-tier'), 10);
          el.classList.toggle('is-unlocked', count >= min);
          el.classList.toggle('is-next', nextMin === min);
        });
      }
      if (this.statusEl) {
        var msg;
        if (!state.next && state.current) {
          msg = 'Maximum savings: <span>' + state.current.pct + '% off everything</span> at checkout.';
        } else if (state.current) {
          var need = state.next.min - count;
          msg = '<span>' + state.current.pct + '% off everything</span> unlocked. Add ' + need + ' more for <span>' + state.next.pct + '% off</span>.';
        } else {
          msg = this.pairingSentence(state.next.pct);
        }
        this.statusEl.innerHTML = msg;
        this.statusEl.classList.toggle('is-max', !state.next);
      }
      if (this.chipEl) {
        if (state.current) {
          this.chipEl.hidden = false;
          this.chipEl.textContent = state.current.pct + '% off everything at checkout';
        } else {
          this.chipEl.hidden = true;
          this.chipEl.textContent = '';
        }
      }
    },

    updateTotal: function () {
      if (!this.root) return;
      var extras = 0;
      var picked = 0;
      if (this.list) {
        this.list.querySelectorAll('[data-fz-fbt-check]:checked').forEach(function (cb) {
          extras += parseInt(cb.getAttribute('data-price'), 10) || 0;
          picked += 1;
        });
      }
      var qty = this.mainQty();
      var count = qty + picked;
      // Pre-discount total on purpose: bundle savings are disclosed, not priced, on the PDP (GMC).
      var total = (this.mainPrice || 0) * qty + extras;
      if (this.summaryEl) this.summaryEl.hidden = picked === 0;
      if (this.countEl) this.countEl.textContent = count + (count === 1 ? ' item' : ' items');
      if (this.totalEl) this.totalEl.textContent = this.formatMoney(total);
      this.renderLadder(count);
    }
  };

  /* ═══════════════════════════════════════════════════════
     7. PRODUCT VARIANT SELECTION
     ═══════════════════════════════════════════════════════ */
  function initVariantSelection() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var jsonEl = form.querySelector('[data-product-json]');
      if (!jsonEl) return;

      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var selects = form.querySelectorAll('[data-option-select]');
      var variantIdInput = form.querySelector('[name="id"]');
      var priceEl = form.querySelector('[data-product-price]');
      var comparePriceEl = form.querySelector('[data-product-compare-price]');
      var stockEl = form.querySelector('[data-product-stock]');
      var addBtn = form.querySelector('[data-add-to-cart]');
      var addBtnText = form.querySelector('[data-add-to-cart-text]');
      var mainImg = document.querySelector('[data-gallery-main]');

      function getSelectedOptions() {
        var opts = [];
        selects.forEach(function (sel) { opts.push(sel.value); });
        return opts;
      }

      function findVariant(opts) {
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var match = true;
          for (var j = 0; j < opts.length; j++) {
            if (v.options[j] !== opts[j]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }

      function updateVariant() {
        var opts = getSelectedOptions();
        var variant = findVariant(opts);

        if (!variant) {
          if (addBtn) { addBtn.disabled = true; }
          if (addBtnText) addBtnText.textContent = 'Unavailable';
          return;
        }

        if (variantIdInput) variantIdInput.value = variant.id;

        if (priceEl) priceEl.textContent = '$' + (variant.price / 100).toFixed(2);
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = '$' + (variant.compare_at_price / 100).toFixed(2);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        if (stockEl) {
          if (variant.available) {
            stockEl.textContent = 'In Stock';
            stockEl.className = stockEl.className.replace(/text-red-\d+/g, '').trim() + ' text-green-600';
          } else {
            stockEl.textContent = 'Sold Out';
            stockEl.className = stockEl.className.replace(/text-green-\d+/g, '').trim() + ' text-red-500';
          }
        }

        if (addBtn) addBtn.disabled = !variant.available;
        if (addBtnText) addBtnText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

        if (mainImg && variant.featured_image) {
          mainImg.src = variant.featured_image.src;
          mainImg.alt = variant.featured_image.alt || product.title;
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.toString());
      }

      selects.forEach(function (sel) {
        sel.addEventListener('change', updateVariant);
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = variantIdInput ? variantIdInput.value : null;
        if (!id) return;
        if (addBtn) addBtn.disabled = true;
        if (addBtnText) addBtnText.textContent = 'Adding...';

        CartDrawer.addToCart(parseInt(id, 10), 1);

        setTimeout(function () {
          if (addBtn) addBtn.disabled = false;
          if (addBtnText) addBtnText.textContent = 'Add to Cart';
        }, 1200);
      });
    });
  }

  /* ═══════════════════════════════════════════════════════
     8. SEARCH (Predictive Search API)
     ═══════════════════════════════════════════════════════ */
  function initSearch() {
    var toggles = document.querySelectorAll('[data-search-toggle]');
    var modal = document.querySelector('[data-search-modal]');
    if (!modal) {
      modal = document.createElement('div');
      modal.setAttribute('data-search-modal', '');
      modal.className = 'fixed inset-0 z-[1000] hidden';
      modal.innerHTML =
        '<div class="absolute inset-0 bg-black/50" data-search-close></div>' +
        '<div class="absolute top-0 left-0 right-0 bg-white shadow-2xl p-6 max-w-2xl mx-auto mt-20 rounded-2xl">' +
          '<div class="flex items-center gap-3 mb-4">' +
            '<svg class="w-5 h-5 text-brand-ink/40 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path stroke-linecap="round" d="m21 21-4.35-4.35"/></svg>' +
            '<input type="search" data-search-input placeholder="Search toys, beds, calming products…" class="flex-1 text-brand-ink outline-none text-base placeholder:text-brand-ink/45" autocomplete="off">' +
            '<button data-search-close class="p-2 text-gray-400 hover:text-brand-ink transition-colors" aria-label="Close search">' +
              '<svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>' +
            '</button>' +
          '</div>' +
          '<div data-search-results class="max-h-[60vh] overflow-y-auto"></div>' +
        '</div>';
      document.body.appendChild(modal);
    }

    var input = modal.querySelector('[data-search-input]');
    var resultsContainer = modal.querySelector('[data-search-results]');
    if (!document.getElementById('furzzee-search-native-clear-fix')) {
      var fixStyle = document.createElement('style');
      fixStyle.id = 'furzzee-search-native-clear-fix';
      fixStyle.textContent =
        '[data-search-input]::-webkit-search-cancel-button{display:none;-webkit-appearance:none;}' +
        '[data-search-input]::-webkit-search-decoration{display:none;-webkit-appearance:none;}' +
        '[data-search-input]::-ms-clear{display:none;width:0;height:0;}';
      document.head.appendChild(fixStyle);
    }

    var debounceTimer;
    var recommendedLoaded = false;
    var recommendedProducts = [];
    var catalogProducts = [];
    var catalogLoaded = false;

    function openSearch() {
      modal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 100);
      if (!input.value.trim()) {
        renderRecommended();
      }
    }

    function closeSearch() {
      modal.classList.add('hidden');
      document.body.style.overflow = '';
      input.value = '';
      resultsContainer.innerHTML = '';
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openSearch();
      });
    });

    modal.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.classList.contains('hidden')) closeSearch();
    });

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var q = input.value.trim();
        if (q.length === 0) {
          renderRecommended();
          return;
        }
        debounceTimer = setTimeout(function () { performSearch(q); }, 300);
      });
    }

    function productPrice(product) {
      if (product.price) {
        return '$' + parseFloat(product.price).toFixed(2);
      }
      if (product.variants && product.variants[0] && product.variants[0].price) {
        return '$' + parseFloat(product.variants[0].price).toFixed(2);
      }
      return '';
    }

    function productImage(product) {
      if (product.image) return product.image;
      if (product.images && product.images[0] && product.images[0].src) return product.images[0].src;
      return '';
    }

    function productUrl(product) {
      if (product.url) return product.url;
      if (product.handle) return '/products/' + product.handle;
      return '#';
    }

    function renderProductRows(products, heading) {
      var html = '';
      if (heading) {
        html += '<div class="px-1 py-2 text-[11px] uppercase tracking-wider font-bold text-brand-ink/50">' + heading + '</div>';
      }
      html += '<div class="divide-y divide-gray-100">';
      products.forEach(function (p) {
        var img = productImage(p);
        var price = productPrice(p);
        html += '<a href="' + productUrl(p) + '" class="flex items-center gap-3 py-3 px-2 hover:bg-brand-cream rounded-lg transition-colors">' +
          (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title || '') + '" class="w-12 h-12 object-cover rounded-md flex-shrink-0" loading="lazy">' : '') +
          '<div class="flex-1 min-w-0">' +
            '<p class="font-heading font-semibold text-sm text-brand-ink truncate">' + escapeHtml(p.title || '') + '</p>' +
            (price ? '<p class="text-xs text-brand-ink/55">' + price + '</p>' : '') +
          '</div>' +
        '</a>';
      });
      html += '</div>';
      resultsContainer.innerHTML = html;
    }

    function renderRecommended() {
      if (recommendedLoaded && recommendedProducts.length > 0) {
        renderProductRows(recommendedProducts, 'Recommended for you');
        return;
      }
      fetch('/products.json?limit=8', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products) ? data.products.slice(0, 6) : [];
          recommendedProducts = products;
          recommendedLoaded = true;
          if (products.length > 0) {
            renderProductRows(products, 'Recommended for you');
          } else {
            resultsContainer.innerHTML = '<p class="text-center text-brand-ink/50 py-8">Start typing to search products.</p>';
          }
        })
        .catch(function () {
          resultsContainer.innerHTML = '<p class="text-center text-brand-ink/50 py-8">Start typing to search products.</p>';
        });
    }

    function normalizeSearchText(str) {
      return String(str || '')
        .toLowerCase()
        // Pipe titles like "Name | Descriptor" break naive matching
        .replace(/[|\/\\,_·•–—]+/g, ' ')
        .replace(/[^a-z0-9\s-]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function searchTokens(query) {
      var stop = {
        a: 1, an: 1, and: 1, for: 1, from: 1, the: 1, with: 1, of: 1, to: 1, in: 1,
        our: 1, your: 1, pet: 1
      };
      return normalizeSearchText(query).split(' ').filter(function (tok) {
        return tok && tok.length > 1 && !stop[tok];
      });
    }

    function productHaystack(product) {
      var parts = [
        product.title || '',
        product.product_type || '',
        product.type || '',
        product.handle || '',
        product.vendor || '',
        Array.isArray(product.tags) ? product.tags.join(' ') : String(product.tags || '')
      ];
      if (product.body) {
        // Suggest API includes HTML body — strip tags for matching
        parts.push(String(product.body).replace(/<[^>]+>/g, ' '));
      }
      if (product.variants && product.variants.length) {
        product.variants.forEach(function (v) {
          if (v && v.sku) parts.push(v.sku);
          if (v && v.title) parts.push(v.title);
        });
      }
      return normalizeSearchText(parts.join(' '));
    }

    function matchesQuery(product, query) {
      var tokens = searchTokens(query);
      if (!tokens.length) return true;
      var hay = productHaystack(product);
      // Prefer all meaningful tokens; if query is long, allow near-match (≥70%)
      var hits = 0;
      for (var i = 0; i < tokens.length; i++) {
        if (hay.indexOf(tokens[i]) !== -1) hits += 1;
      }
      if (hits === tokens.length) return true;
      if (tokens.length >= 4 && hits / tokens.length >= 0.7) return true;
      return false;
    }

    function suggestUrl(query) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      if (root.slice(-1) !== '/') root += '/';
      // Sanitize before hitting Shopify predictive search (pipe/punct can zero results)
      var cleaned = normalizeSearchText(query);
      return root + 'search/suggest.json?q=' + encodeURIComponent(cleaned || query);
    }

    function loadCatalog() {
      if (catalogLoaded) return Promise.resolve(catalogProducts);
      function fetchPage(page, acc) {
        return fetch('/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var batch = (data && data.products) ? data.products : [];
            acc = acc.concat(batch);
            if (batch.length < 250 || page >= 8) {
              catalogProducts = acc;
              catalogLoaded = true;
              return catalogProducts;
            }
            return fetchPage(page + 1, acc);
          });
      }
      return fetchPage(1, []).catch(function () {
        return [];
      });
    }

    function rankProducts(products, query) {
      var tokens = searchTokens(query);
      return (products || []).slice().sort(function (a, b) {
        var ha = productHaystack(a);
        var hb = productHaystack(b);
        var sa = 0;
        var sb = 0;
        tokens.forEach(function (tok) {
          if (ha.indexOf(tok) !== -1) sa += 1;
          if (hb.indexOf(tok) !== -1) sb += 1;
          if ((a.title || '').toLowerCase().indexOf(tok) !== -1) sa += 2;
          if ((b.title || '').toLowerCase().indexOf(tok) !== -1) sb += 2;
        });
        return sb - sa;
      });
    }

    function performSearch(query) {
      resultsContainer.innerHTML = '<p class="text-center text-brand-ink/50 py-6">Searching…</p>';

      function finishWith(list) {
        var ranked = rankProducts(list, query).slice(0, 10);
        if (ranked.length === 0) {
          resultsContainer.innerHTML = '<p class="text-center text-brand-ink/50 py-8">No products matched "' + escapeHtml(query) + '".</p>';
          return;
        }
        renderProductRows(ranked, '');
      }

      function catalogFallback() {
        return loadCatalog().then(function (catalog) {
          finishWith((catalog || []).filter(function (p) { return matchesQuery(p, query); }));
        });
      }

      // Bare suggest.json (no resources[type]) — resources[type]=product 422s on this store.
      fetch(suggestUrl(query), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('suggest ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          var filtered = products.filter(function (p) { return matchesQuery(p, query); });
          if (filtered.length > 0) {
            finishWith(filtered);
            return;
          }
          // Suggest returned hits but token filter was strict — still show them
          if (products.length > 0) {
            finishWith(products);
            return;
          }
          // Second pass: significant tokens only (e.g. "tactical harness")
          var significant = searchTokens(query).filter(function (t) {
            return ['dog', 'cat', 'pet', 'large', 'breeds', 'adjustable'].indexOf(t) === -1;
          }).slice(0, 3).join(' ');
          if (significant && significant !== normalizeSearchText(query)) {
            return fetch(suggestUrl(significant), { credentials: 'same-origin' })
              .then(function (r) {
                if (!r.ok) return { resources: { results: { products: [] } } };
                return r.json();
              })
              .then(function (data2) {
                var more = (data2.resources && data2.resources.results && data2.resources.results.products) || [];
                if (more.length > 0) {
                  finishWith(more);
                  return;
                }
                return catalogFallback();
              });
          }
          return catalogFallback();
        })
        .catch(function () {
          return catalogFallback();
        });
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }
  }

  /* ═══════════════════════════════════════════════════════
     9. SCROLL REVEAL (IntersectionObserver)
     ═══════════════════════════════════════════════════════ */
  function initScrollReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (els.length === 0) return;

    els.forEach(function (el) {
      var dir = el.dataset.revealDirection || 'up';
      var ty = dir === 'down' ? '-20px' : dir === 'left' ? '0' : dir === 'right' ? '0' : '20px';
      var tx = dir === 'left' ? '20px' : dir === 'right' ? '-20px' : '0';
      el.style.opacity = '0';
      el.style.transform = 'translate(' + tx + ', ' + ty + ')';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      var delay = el.dataset.revealDelay;
      if (delay) el.style.transitionDelay = delay + 'ms';
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translate(0, 0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ═══════════════════════════════════════════════════════
     10. SCROLL TO TOP
     ═══════════════════════════════════════════════════════ */
  function initScrollToTop() {
    if (window.performance && window.performance.navigation) {
      if (window.performance.navigation.type === 1) return;
    }
    if (window.scrollY > 200) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }

  /* ═══════════════════════════════════════════════════════
     11. TRACK ORDER FORM + TRACK123 CARRIER FALLBACK
     Track123 often mis-detects Chinese ZS* numbers as GLS and
     shows an empty timeline. Offer 17TRACK as the carrier view.
     ═══════════════════════════════════════════════════════ */
  /* track-fix-20260720 */
  var TRACK123_FALLBACK_BASE = 'https://t.17track.net/en#nums=';

  function build17TrackUrl(trackingNumber) {
    return TRACK123_FALLBACK_BASE + encodeURIComponent(trackingNumber);
  }

  function initTrackOrderForm() {
    var form = document.querySelector('[data-track-order-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('[data-tracking-input]');
      var trackingNumber = input ? input.value.trim() : '';
      if (!trackingNumber) return;

      var baseUrl =
        form.dataset.trackerUrl ||
        form.dataset.aftershipUrl ||
        TRACK123_FALLBACK_BASE;
      var url;
      if (baseUrl.indexOf('#nums=') !== -1 || /[?&]nums=$/.test(baseUrl)) {
        url = baseUrl + encodeURIComponent(trackingNumber);
      } else {
        if (baseUrl.charAt(baseUrl.length - 1) !== '/' && baseUrl.charAt(baseUrl.length - 1) !== '=') {
          baseUrl += '/';
        }
        url = baseUrl + encodeURIComponent(trackingNumber);
      }

      window.open(url, '_blank', 'noopener');
    });
  }

  function extractTrack123Number() {
    try {
      var params = new URLSearchParams(window.location.search);
      var fromQuery = params.get('nums') || params.get('tracking_number') || params.get('trackingNo');
      if (fromQuery) return fromQuery.trim();
    } catch (err) {}

    var candidates = document.querySelectorAll(
      '.track123_track_wrapper, [class*="track123"], main'
    );
    var root = candidates.length ? candidates[0] : document.body;
    var text = root ? root.textContent || '' : '';
    var match = text.match(/\b(ZS\d{10,}|UL\d{9,}[A-Z]{2}|[A-Z]{2}\d{9}[A-Z]{2})\b/i);
    return match ? match[1] : '';
  }

  function ensureTrack123FallbackBanner(trackingNumber) {
    if (!trackingNumber) return;
    var existing = document.getElementById('fz-track123-fallback');
    if (existing) {
      var link = existing.querySelector('a[data-fz-17track]');
      if (link) link.setAttribute('href', build17TrackUrl(trackingNumber));
      return;
    }

    var banner = document.createElement('div');
    banner.id = 'fz-track123-fallback';
    banner.setAttribute('role', 'region');
    banner.setAttribute('aria-label', 'Carrier tracking backup');
    banner.style.cssText =
      'position:sticky;top:0;z-index:40;width:100%;background:#0A0A0A;color:#FFFDEB;' +
      'padding:0.75rem 1rem;text-align:center;font-family:Nunito,sans-serif;font-size:0.875rem;';
    banner.innerHTML =
      '<strong style="color:#FACC15">Need live scan updates?</strong> ' +
      'Chinese logistics numbers sometimes stall here. ' +
      '<a data-fz-17track href="' +
      build17TrackUrl(trackingNumber) +
      '" target="_blank" rel="noopener" ' +
      'style="color:#FACC15;text-decoration:underline;font-weight:700;">Open 17TRACK</a>' +
      ' for the carrier timeline.';

    var main = document.querySelector('main') || document.body;
    main.insertBefore(banner, main.firstChild);
  }

  function initTrack123Fallback() {
    if (window.location.pathname.indexOf('/apps/track123') === -1) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      var number = extractTrack123Number();
      if (number) {
        ensureTrack123FallbackBanner(number);
        clearInterval(timer);
      } else if (tries >= 20) {
        clearInterval(timer);
      }
    }, 500);
  }

  function initTrackOrderLinks() {
    /* Keep /pages/track-order on the branded 17TRACK form; leave Track123 links as-is. */
  }

  /* ═══════════════════════════════════════════════════════
     12. POLICY BRAND SANITIZER
     ═══════════════════════════════════════════════════════ */
  function initProductDescSanitize() {
    // Strip import placeholders / empty srcs so description never shows broken-image icons.
    document.querySelectorAll('[data-fz-sanitize-desc], .furzzee-product-desc').forEach(function (root) {
      root.querySelectorAll('img').forEach(function (img) {
        var src = (img.getAttribute('src') || '').trim();
        var bad = !src ||
          /IMAGE_URL/i.test(src) ||
          src.charAt(0) === '<' ||
          src.indexOf('&lt;') === 0 ||
          src === 'undefined' ||
          src === 'null' ||
          src === '#' ||
          src === 'about:blank';
        function removeImg() {
          var wrap = img.parentElement;
          img.remove();
          if (
            wrap &&
            wrap !== root &&
            wrap.tagName === 'DIV' &&
            !(wrap.textContent || '').trim() &&
            !wrap.querySelector('img,video,iframe')
          ) {
            wrap.remove();
          }
        }
        if (bad) {
          removeImg();
          return;
        }
        img.addEventListener('error', removeImg, { once: true });
      });
    });
  }

  function initPolicyBrandSanitizer() {
    /* Disabled: policy pages now render fully via sections/policy-content.liquid (Canada-only).
       This legacy client-side override injected stale US-only copy and must never run. */
    return;
    /* eslint-disable no-unreachable */
    if (!window.location.pathname || window.location.pathname.indexOf('/policies/') !== 0) return;
    var path = window.location.pathname.toLowerCase();
    var container = document.querySelector('.shopify-policy__container');
    if (!container) return;

    var policies = {
      '/policies/privacy-policy': {
        title: 'Privacy Policy',
        icon: '🐾',
        updated: 'Last updated: January 2025',
        body:
          '<p>This Privacy Policy describes how FURZZEE (the "<strong>Site</strong>", "<strong>we</strong>", "<strong>us</strong>", or "<strong>our</strong>") collects, uses, and discloses your personal information when you visit, use our services, or make a purchase from furzzee.com.</p>' +
          '<p>Please read this Privacy Policy carefully. By using and accessing any of the Services, you agree to the collection, use, and disclosure of your information as described in this Privacy Policy.</p>' +
          '<p class="not-prose bg-brand-cream/60 border border-brand-yellow/40 rounded-2xl p-4 text-sm"><strong>US-only service.</strong> FURZZEE sells, ships, and provides customer support exclusively within the United States.</p>' +
          '<h2>Changes to This Privacy Policy</h2><p>We may update this Privacy Policy from time to time, including to reflect changes to our practices or for other operational, legal, or regulatory reasons.</p>' +
          '<h2>How We Collect and Use Your Personal Information</h2><p>To provide the Services, we collect personal information from a variety of sources depending on how you interact with FURZZEE.</p>' +
          '<h3>Information We Collect Directly from You</h3><ul><li><strong>Basic contact details</strong> — your name, shipping address, phone number, and email.</li><li><strong>Order information</strong> — your name, billing address, shipping address, payment confirmation, email, and phone number.</li><li><strong>Account information</strong> — your username, password, and any security questions tied to your account.</li><li><strong>Shopping information</strong> — the products you view, add to your cart, or save for later.</li><li><strong>Customer support information</strong> — anything you choose to include when contacting us.</li></ul>' +
          '<h3>Information We Collect Through Cookies</h3><p>We collect Usage Data using cookies, pixels, and similar technologies to improve and optimize our services.</p>' +
          '<h2>How We Disclose Personal Information</h2><ul><li>With vendors and service providers supporting payments, fulfillment, analytics, and support.</li><li>With marketing partners where permitted.</li><li>When required to comply with legal obligations.</li></ul>' +
          '<h2>Your US Privacy Rights</h2><p>Depending on your US state of residence, you may have rights to access, delete, correct, portability, and opt out where applicable.</p>' +
          '<h2>Contact Us</h2><p>Email: <a href="mailto:info@furzzee.com">info@furzzee.com</a><br>Phone: <a href="tel:+14375250022">+1 (437) 525-0022</a><br>Address: 55 Smooth Rose Court, North York, ON M2J 0G7</p>'
      },
      '/policies/refund-policy': {
        title: 'Refund & Return Policy',
        icon: '🐾',
        updated: 'Last updated: January 2025',
        body:
          '<p>We offer a <strong>30-day return window</strong> from the date you receive your FURZZEE order.</p>' +
          '<h2>Eligibility for Returns</h2><ul><li>Unused, unwashed, with original tags and packaging.</li><li>Free of fur, scents, marks, or chew evidence.</li><li>Requested within 30 days of delivery.</li></ul>' +
          '<h2>How to Start a Return</h2><p>Email <a href="mailto:info@furzzee.com">info@furzzee.com</a> to initiate a return.</p>' +
          '<h2>Return Shipping</h2><p>Customers are responsible for return shipping unless the item was damaged, defective, or incorrect on arrival.</p>' +
          '<h2>Damaged or Incorrect Items</h2><p>Contact us within <strong>7 days</strong> of delivery with clear photos.</p>' +
          '<h2>Missing or Stolen Deliveries</h2><p>If tracking shows delivered but you cannot find your package, check with neighbors and your local <strong>Canada Post, USPS, UPS, or FedEx</strong> office. Contact us within <strong>14 days</strong> of the marked delivery date.</p>' +
          '<h2>Refunds</h2><p>Approved refunds are issued to your original payment method within <strong>10 business days</strong>.</p>' +
          '<h2>Contact Us</h2><p>Email: <a href="mailto:info@furzzee.com">info@furzzee.com</a><br>Phone: <a href="tel:+14375250022">+1 (437) 525-0022</a></p>'
      },
      '/policies/shipping-policy': {
        title: 'Shipping Policy',
        icon: '📦',
        updated: 'Last updated: January 2025',
        body:
          '<p>At Furzzee, we are committed to getting your order to you in a smooth, reliable way.</p>' +
          '<h2>Shipping Destinations</h2><p>We ship to <strong>Canada</strong> (all provinces and territories) and the <strong>United States</strong> (all 50 states).</p>' +
          '<h2>Processing & Delivery Time</h2><ul><li><strong>Order cutoff:</strong> 3:00 PM (ET)</li><li><strong>Processing:</strong> 0–1 business day</li><li><strong>Transit:</strong> 6–10 business days across Canada and the USA</li><li><strong>Total delivery:</strong> 6–11 business days across Canada and the USA</li></ul>' +
          '<h2>Shipping Partners</h2><p>Canada Post, USPS, UPS, FedEx, and DHL.</p>' +
          '<h2>Shipping Fees</h2><p><strong>Free standard shipping across Canada and the USA</strong>, no minimum required.</p>' +
          '<h2>Order Tracking</h2><p>Use our <a href="/apps/track123">Track Your Order</a> page after shipment.</p>' +
          '<h2>Lost, Stolen, or Damaged Packages</h2><p>Email <a href="mailto:info@furzzee.com">info@furzzee.com</a> and we will resolve quickly.</p>'
      },
      '/policies/terms-of-service': {
        title: 'Terms of Service',
        icon: '📜',
        updated: 'Last updated: January 2025',
        body:
          '<h2>Overview</h2><p>This website is operated by FURZZEE. By browsing the Site or buying a product from us, you agree to these Terms of Service.</p>' +
          '<h2>Online Store Terms</h2><p>You agree not to use our products or Service for any unlawful or unauthorized purpose.</p>' +
          '<h2>Products & Pricing</h2><ul><li><strong>All applicable taxes are included in the listed price</strong> — the price you see is the price you pay, with no hidden fees. Your checkout currency matches your market (<strong>USD</strong> in the United States, <strong>CAD</strong> in Canada).</li><li>Prices and availability may change without notice.</li></ul>' +
          '<h2>Orders, Payment & Shipping</h2><p>Orders may be accepted or declined at our discretion. Shipping details are in our Shipping Policy.</p>' +
          '<h2>Governing Law</h2><p>These Terms are governed by the laws of the United States.</p>' +
          '<h2>Contact Us</h2><p>Email: <a href="mailto:info@furzzee.com">info@furzzee.com</a><br>Phone: <a href="tel:+14375250022">+1 (437) 525-0022</a></p>'
      }
    };

    var policy = policies[path];
    if (!policy) return;

    container.innerHTML =
      '<article class="max-w-3xl mx-auto px-4 py-16 lg:py-24">' +
        '<header class="mb-10 text-center">' +
          '<div class="text-5xl mb-4">' + policy.icon + '</div>' +
          '<h1 class="font-heading font-bold text-4xl lg:text-5xl text-brand-ink">' + policy.title + '</h1>' +
          '<p class="mt-3 text-sm text-brand-ink/55">' + policy.updated + '</p>' +
        '</header>' +
        '<div class="prose prose-lg max-w-none text-brand-ink/90 space-y-6 leading-relaxed">' + policy.body + '</div>' +
      '</article>';

    document.title = policy.title + ' — FURZZEE';
  }

  /* ═══════════════════════════════════════════════════════
     NEWSLETTER / FIRST-ORDER OFFER (site-wide)
     ═══════════════════════════════════════════════════════ */
  function initNewsletterOffer() {
    var fab = document.querySelector('[data-fz-offer-fab]');
    var modal = document.querySelector('[data-fz-offer-modal]');
    if (!fab || !modal) return;

    var panel = modal.querySelector('.fz-offer-modal__panel');
    var form = document.getElementById('fz-offer-form');
    var frame = document.getElementById('fz-offer-frame');
    var success = modal.querySelector('[data-fz-offer-success]');
    var submitBtn = form ? form.querySelector('[data-fz-offer-form-submit]') : null;
    var errorEl = modal.querySelector('[data-fz-offer-error]');
    var emailInput = modal.querySelector('#fz-offer-email');
    var copyBtn = modal.querySelector('[data-fz-offer-copy]');
    var codeEl = modal.querySelector('[data-fz-offer-code]');
    var successEmailEl = modal.querySelector('[data-fz-offer-success-email]');
    var STORAGE_POPUP_SEEN = 'fz_offer_popup_seen_v3';
    var STORAGE_SUBSCRIBED = 'fz_offer_subscribed_v2';
    var STORAGE_EMAIL = 'fz_offer_email';

    try {
      localStorage.removeItem('fz_offer_closed');
    } catch (e) { /* ignore */ }

    if (form) {
      form.setAttribute('data-nocaptcha', 'true');
    }

    function markPopupSeen() {
      try {
        sessionStorage.setItem(STORAGE_POPUP_SEEN, '1');
      } catch (e) { /* ignore */ }
    }
    function isSubscribed() {
      try {
        return localStorage.getItem(STORAGE_SUBSCRIBED) === '1';
      } catch (e) {
        return false;
      }
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function maskEmail(email) {
      var parts = (email || '').split('@');
      if (parts.length !== 2 || !parts[0]) return '';
      var local = parts[0];
      var masked = local.length <= 2
        ? local.charAt(0) + '***'
        : local.charAt(0) + '***' + local.charAt(local.length - 1);
      return masked + '@' + parts[1];
    }

    function getStoredEmail() {
      try {
        return localStorage.getItem(STORAGE_EMAIL) || '';
      } catch (e) {
        return '';
      }
    }

    function showFormState() {
      if (form) form.hidden = false;
      if (success) success.hidden = true;
      if (panel) panel.classList.remove('fz-offer-modal__panel--reveal');
      resetSubmitBtn();
    }

    function showSuccessState(email) {
      if (form) form.hidden = true;
      if (success) {
        success.hidden = false;
        if (panel) panel.classList.add('fz-offer-modal__panel--reveal');
        if (successEmailEl) {
          var displayEmail = email || getStoredEmail();
          if (displayEmail) {
            successEmailEl.textContent = 'Saved: ' + maskEmail(displayEmail);
            successEmailEl.hidden = false;
          } else {
            successEmailEl.textContent = '';
            successEmailEl.hidden = true;
          }
        }
        if (codeEl) {
          codeEl.classList.remove('fz-offer-pop');
          void codeEl.offsetWidth;
          codeEl.classList.add('fz-offer-pop');
        }
      }
      if (email) {
        try { localStorage.setItem(STORAGE_EMAIL, email); } catch (e) { /* ignore */ }
      }
      try { localStorage.setItem(STORAGE_SUBSCRIBED, '1'); } catch (e) { /* ignore */ }
      showFab();
      if (window.FurzzeeCartDrawer && typeof window.FurzzeeCartDrawer.updateCheckoutLink === 'function') {
        window.FurzzeeCartDrawer.updateCheckoutLink();
      }
    }

    function openModal() {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      clearError();
      if (isSubscribed()) {
        showSuccessState();
      } else {
        showFormState();
        // Only auto-focus on desktop — on mobile this pops the keyboard,
        // covering the close button and making the popup hard to dismiss.
        var isTouch = window.matchMedia && window.matchMedia('(hover: none)').matches;
        if (emailInput && !isTouch) emailInput.focus();
      }
    }

    function closeModal(persist) {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (persist) markPopupSeen();
      showFab();
    }

    function showFab() {
      fab.removeAttribute('hidden');
    }

    // FAB stays visible; modal opens only on FAB click (no auto / exit-intent / delayed show).
    showFab();
    if (isSubscribed()) {
      showSuccessState();
    }

    fab.addEventListener('click', function () {
      openModal();
    });

    modal.querySelectorAll('[data-fz-offer-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal(true);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal(true);
    });

    if (copyBtn && codeEl && navigator.clipboard) {
      copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(codeEl.textContent.trim()).then(function () {
          copyBtn.textContent = 'Copied!';
          setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 1800);
        });
      });
    }

    function resetSubmitBtn() {
      if (!submitBtn) return;
      submitBtn.disabled = false;
      submitBtn.textContent = 'Get my 10% code';
    }

    function submitNewsletter(email) {
      if (!form || !frame) {
        showError('Please try again in a moment.');
        resetSubmitBtn();
        return;
      }
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending…';
      }
      form.setAttribute('target', 'fz-offer-frame');
      window.setTimeout(function () {
        showSuccessState(email);
      }, 800);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        clearError();
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email) {
          e.preventDefault();
          showError('Please enter your email to get your code.');
          return;
        }
        submitNewsletter(email);
      });
    }
  }

  function initCollectionFilters() {
    var drawer = document.querySelector('[data-fz-filter-drawer]');
    if (drawer) {
      var openBtn = document.querySelector('[data-fz-filter-open]');
      var closeBtns = drawer.querySelectorAll('[data-fz-filter-close]');

      function openDrawer() {
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
        });
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        window.setTimeout(function () {
          drawer.hidden = true;
        }, 280);
      }

      if (openBtn) {
        openBtn.addEventListener('click', function (e) {
          e.preventDefault();
          openDrawer();
        });
      }
      closeBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          closeDrawer();
        });
      });
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) closeDrawer();
      });
      var closeLinks = drawer.querySelectorAll('[data-fz-filter-close-link]');
      closeLinks.forEach(function (link) {
        link.addEventListener('click', function () { closeDrawer(); });
      });
      drawer.querySelectorAll('[data-fz-filter-form]').forEach(function (form) {
        form.addEventListener('submit', function () { closeDrawer(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      });
    }

    document.querySelectorAll('[data-fz-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });

    initBedsNeedSizeFilters();
  }

  /* GMC-safe beds need/size chips: filter across the FULL collection (not just this page) */
  function initBedsNeedSizeFilters() {
    var grids = document.querySelectorAll('[data-fz-beds-grid]');
    if (!grids.length) return;

    var need = '';
    var size = '';
    var params = new URLSearchParams(window.location.search);
    if (params.get('need')) need = String(params.get('need')).toLowerCase();
    if (params.get('size')) size = String(params.get('size')).toLowerCase();

    var primaryGrid = grids[0];
    var collectionHandle = primaryGrid.getAttribute('data-fz-collection-handle') || '';
    if (!collectionHandle) {
      var m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      if (m) collectionHandle = m[1];
    }
    var originalHtmlByGrid = [];
    grids.forEach(function (grid) {
      originalHtmlByGrid.push(grid.innerHTML);
    });
    var catalogPromise = null;
    var filterRequestId = 0;
    var gridWasReplaced = false;

    function moneyFromCents(cents) {
      var n = Number(cents) / 100;
      if (isNaN(n)) return '';
      try {
        return (window.Shopify && Shopify.formatMoney)
          ? Shopify.formatMoney(cents)
          : ('$' + n.toFixed(2));
      } catch (e) {
        return '$' + n.toFixed(2);
      }
    }

    function syncPillGroup(selector, activeValue) {
      document.querySelectorAll(selector).forEach(function (btn) {
        var val = btn.getAttribute(selector.indexOf('need') >= 0 ? 'data-fz-need-filter' : 'data-fz-size-filter') || '';
        var on = val === activeValue;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function setPaginationVisible(show) {
      document.querySelectorAll('[data-fz-collection-pagination]').forEach(function (nav) {
        nav.hidden = !show;
        nav.style.display = show ? '' : 'none';
      });
    }

    function setEmptyVisible(show, msg) {
      document.querySelectorAll('[data-fz-filter-empty]').forEach(function (el) {
        if (show) {
          el.hidden = false;
          el.classList.add('is-visible');
          var msgEl = el.querySelector('[data-fz-filter-empty-msg]');
          if (msgEl && msg) msgEl.textContent = msg;
        } else {
          el.hidden = true;
          el.classList.remove('is-visible');
        }
      });
    }

    function extractNeeds(product) {
      var tags = Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || '');
      var blob = (product.title + ' ' + (product.product_type || '') + ' ' + tags).toLowerCase();
      var tokens = [];
      if (blob.indexOf('orthopedic') !== -1 || blob.indexOf('ortho') !== -1) tokens.push('orthopedic');
      if (blob.indexOf('waterproof') !== -1 || blob.indexOf('water-proof') !== -1) tokens.push('waterproof');
      if (blob.indexOf('calming') !== -1 || blob.indexOf('anxiety') !== -1 || blob.indexOf('anti-anxiety') !== -1) tokens.push('calming');
      if (blob.indexOf('cooling') !== -1 || blob.indexOf('ice silk') !== -1 || blob.indexOf('gel') !== -1) tokens.push('cooling');
      if (blob.indexOf('car seat') !== -1 || blob.indexOf('booster') !== -1 || blob.indexOf('travel cushion') !== -1 || blob.indexOf('car bed') !== -1) tokens.push('car-seat');
      if (blob.indexOf('large') !== -1 || blob.indexOf('xl') !== -1 || blob.indexOf('xxl') !== -1 || blob.indexOf('3xl') !== -1) tokens.push('large');
      if (blob.indexOf('mat') !== -1 || blob.indexOf('mattress') !== -1) tokens.push('mat');
      return tokens;
    }

    function extractSizes(product) {
      var tokens = [];
      (product.options || []).forEach(function (opt) {
        var name = (opt.name || '').toLowerCase();
        if (name.indexOf('size') === -1) return;
        (opt.values || []).forEach(function (val) {
          var token = String(val).toLowerCase().trim().replace(/\s+/g, '-');
          tokens.push(token);
          if (token === 'xxl' || token === 'x-large' || token === 'extra-large') {
            tokens.push('2xl', 'xl');
          }
          if (token === 'xxx-large' || token === '3x-large') {
            tokens.push('3xl');
          }
        });
      });
      return tokens;
    }

    function productMatches(product, needVal, sizeVal) {
      var needs = extractNeeds(product);
      var sizes = extractSizes(product);
      var needsStr = ' ' + needs.join(' ') + ' ';
      var sizesStr = ' ' + sizes.join(' ') + ' ';
      var okNeed = !needVal || needsStr.indexOf(' ' + needVal + ' ') !== -1;
      var okSize = !sizeVal || sizesStr.indexOf(' ' + sizeVal + ' ') !== -1 || sizesStr.indexOf(' ' + sizeVal + '-') !== -1;
      if (sizeVal === 'xl' && !okSize) {
        okSize = sizesStr.indexOf(' xl') !== -1 || sizesStr.indexOf('x-large') !== -1 || sizesStr.indexOf('xxl') !== -1;
      }
      return okNeed && okSize;
    }

    function fetchCollectionCatalog() {
      if (catalogPromise) return catalogPromise;
      if (!collectionHandle) {
        catalogPromise = Promise.resolve([]);
        return catalogPromise;
      }
      var all = [];
      function fetchPage(page) {
        return fetch('/collections/' + collectionHandle + '/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var batch = data.products || [];
            all = all.concat(batch);
            if (batch.length >= 250 && page < 8) return fetchPage(page + 1);
            return all;
          });
      }
      catalogPromise = fetchPage(1).catch(function () { return []; });
      return catalogPromise;
    }

    function cardHtmlFromCollectionProduct(product) {
      var img = product.featured_image;
      if (img && typeof img === 'object') img = img.src || '';
      if (!img && product.images && product.images[0]) {
        img = typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || '');
      }
      var variants = product.variants || [];
      var available = variants.some(function (v) { return v.available; }) || !!product.available;
      var price = Infinity;
      var compare = 0;
      variants.forEach(function (v) {
        var cents = Math.round(parseFloat(v.price) * 100);
        if (!isNaN(cents) && cents < price) {
          price = cents;
          compare = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
        }
      });
      if (price === Infinity) price = 0;
      var onSale = compare > price;
      var pct = onSale ? Math.round((compare - price) / compare * 100) : 0;
      var priceHtml = onSale
        ? '<s class="fz-pcard__was">' + moneyFromCents(compare) + '</s><span>' + moneyFromCents(price) + '</span><span class="fz-pcard__pct">-' + pct + '%</span>'
        : '<span>' + moneyFromCents(price) + '</span>';
      var needs = extractNeeds(product).join(' ');
      var sizes = extractSizes(product).join(' ');
      var imgSrc = img ? String(img).replace(/(\.[^.\/?]+)(\?|$)/, '_600x$1$2') : '';
      return (
        '<article class="fz-pcard" data-fz-pcard data-product-handle="' + CartDrawer.escapeHtml(product.handle) + '" data-fz-needs="' + CartDrawer.escapeHtml(needs) + '" data-fz-sizes="' + CartDrawer.escapeHtml(sizes) + '">' +
          '<a href="/products/' + CartDrawer.escapeHtml(product.handle) + '" class="fz-pcard__link" data-fz-pcard-link aria-label="' + CartDrawer.escapeHtml(product.title) + '">' +
            '<div class="fz-pcard__media">' +
              (imgSrc ? '<img class="fz-pcard__img fz-pcard__img--primary" src="' + CartDrawer.escapeHtml(imgSrc) + '" alt="" width="600" height="600" loading="lazy" data-fz-pcard-img>' : '') +
              (available
                ? '<button type="button" class="fz-pcard__qa" data-fz-qa data-handle="' + CartDrawer.escapeHtml(product.handle) + '" aria-label="Quick add ' + CartDrawer.escapeHtml(product.title) + '">' +
                    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path stroke-linecap="round" d="M12 5v14M5 12h14"/></svg>' +
                    '<span class="fz-pcard__qa-text">Quick add</span></button>'
                : '') +
            '</div>' +
          '</a>' +
          '<div class="fz-pcard__meta">' +
            '<a href="/products/' + CartDrawer.escapeHtml(product.handle) + '" class="fz-pcard__info" data-fz-pcard-info tabindex="-1" aria-hidden="true">' +
              '<h3 class="fz-pcard__title">' + CartDrawer.escapeHtml(product.title) + '</h3>' +
              '<span class="fz-pcard__price" data-fz-pcard-price>' + priceHtml + '</span>' +
            '</a>' +
            '<div class="fz-pcard__swatches fz-pcard__swatches--empty" aria-hidden="true"></div>' +
          '</div>' +
        '</article>'
      );
    }

    function restoreOriginalGrid() {
      grids.forEach(function (grid, idx) {
        grid.innerHTML = originalHtmlByGrid[idx] || '';
        grid.removeAttribute('aria-busy');
      });
      setPaginationVisible(true);
      setEmptyVisible(false);
      gridWasReplaced = false;
      if (typeof initProductCardSwatches === 'function') initProductCardSwatches();
    }

    function renderFilteredProducts(products) {
      var html = products.map(cardHtmlFromCollectionProduct).join('');
      grids.forEach(function (grid, idx) {
        grid.removeAttribute('aria-busy');
        if (idx === 0) grid.innerHTML = html;
        else grid.innerHTML = '';
      });
      gridWasReplaced = true;
      setPaginationVisible(false);
      setEmptyVisible(products.length === 0, 'No beds match those filters.');
    }

    function syncUrl() {
      var url = new URL(window.location.href);
      if (need) url.searchParams.set('need', need); else url.searchParams.delete('need');
      if (size) url.searchParams.set('size', size); else url.searchParams.delete('size');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    function applyFilters() {
      syncPillGroup('[data-fz-need-filter]', need);
      syncPillGroup('[data-fz-size-filter]', size);
      syncUrl();

      if (!need && !size) {
        filterRequestId += 1;
        if (gridWasReplaced) restoreOriginalGrid();
        else {
          setPaginationVisible(true);
          setEmptyVisible(false);
        }
        return;
      }

      var requestId = ++filterRequestId;
      grids.forEach(function (grid) {
        grid.setAttribute('aria-busy', 'true');
      });
      setEmptyVisible(false);
      setPaginationVisible(false);

      fetchCollectionCatalog().then(function (catalog) {
        if (requestId !== filterRequestId) return;
        var matched = (catalog || []).filter(function (p) {
          return productMatches(p, need, size);
        });
        renderFilteredProducts(matched);
      });
    }

    document.querySelectorAll('[data-fz-need-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        need = btn.getAttribute('data-fz-need-filter') || '';
        applyFilters();
      });
    });
    document.querySelectorAll('[data-fz-size-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        size = btn.getAttribute('data-fz-size-filter') || '';
        applyFilters();
      });
    });
    document.querySelectorAll('[data-fz-filter-reset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        need = '';
        size = '';
        applyFilters();
      });
    });

    applyFilters();
    window.__fzMoneyFromCents = moneyFromCents;
  }

  /* Colour swatches on collection cards — update image, URL (?variant=), and real price */
  function initProductCardSwatches() {
    if (!window.__fzMoneyFromCents) {
      window.__fzMoneyFromCents = function (cents) {
        var n = Number(cents) / 100;
        if (isNaN(n)) return '';
        return '$' + n.toFixed(2);
      };
    }
    document.querySelectorAll('[data-fz-pcard]').forEach(function (card) {
      var link = card.querySelector('[data-fz-pcard-link]');
      var info = card.querySelector('[data-fz-pcard-info]');
      var img = card.querySelector('[data-fz-pcard-img]');
      var priceEl = card.querySelector('[data-fz-pcard-price]');
      var swatches = card.querySelectorAll('[data-fz-pcard-swatch]');
      if (!swatches.length) return;

      swatches.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          swatches.forEach(function (s) {
            s.classList.remove('is-active');
            s.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');

          var url = btn.getAttribute('data-variant-url');
          var src = btn.getAttribute('data-img');
          var price = parseInt(btn.getAttribute('data-price'), 10);
          var compare = parseInt(btn.getAttribute('data-compare'), 10) || 0;
          var pct = parseInt(btn.getAttribute('data-pct'), 10) || 0;

          if (url) {
            if (link) link.setAttribute('href', url);
            if (info) info.setAttribute('href', url);
          }
          if (img && src) {
            img.src = src;
            img.setAttribute('data-swatch-locked', 'true');
          }
          if (priceEl && !isNaN(price)) {
            var money = window.__fzMoneyFromCents
              ? window.__fzMoneyFromCents(price)
              : ('$' + (price / 100).toFixed(2));
            var compareMoney = compare > price
              ? (window.__fzMoneyFromCents ? window.__fzMoneyFromCents(compare) : ('$' + (compare / 100).toFixed(2)))
              : '';
            var html = '';
            if (compare > price) {
              html += '<s class="fz-pcard__was">' + compareMoney + '</s>';
            }
            html += '<span data-fz-pcard-now>' + money + '</span>';
            if (compare > price && pct > 0) {
              html += '<span class="fz-pcard__pct">-' + pct + '%</span>';
            }
            priceEl.innerHTML = html;
          }
        });
      });
    });
  }

  /* ═══════════════════════════════════════════════════════
     QUICK ADD (product cards)
     ═══════════════════════════════════════════════════════ */
  var QuickAdd = {
    overlay: null,
    product: null,
    selected: {},
    cache: {},

    init: function () {
      this.overlay = document.querySelector('[data-fz-qa-overlay]');
      if (!this.overlay) return;
      var self = this;

      // Window capture phase: fires before any script can stop propagation
      window.addEventListener('click', function (e) {
        if (!e.target.closest) return;

        var trigger = e.target.closest('[data-fz-qa]');
        if (trigger) {
          e.preventDefault();
          e.stopPropagation();
          self.openFor(trigger.dataset.handle);
          return;
        }

        if (e.target === self.overlay || e.target.closest('[data-fz-qa-close]')) {
          self.close();
          return;
        }

        // Option value selection (delegated)
        var valBtn = e.target.closest('.fz-qa-val');
        if (valBtn && self.overlay && self.overlay.contains(valBtn)) {
          self.selected[valBtn.dataset.pos] = valBtn.dataset.value;
          var group = valBtn.closest('[data-fz-qa-group]');
          group.querySelectorAll('.fz-qa-val').forEach(function (b) {
            b.setAttribute('aria-pressed', b === valBtn ? 'true' : 'false');
          });
          var label = group.querySelector('[data-fz-qa-selected]');
          if (label) label.textContent = valBtn.dataset.value;
          self.syncVariant();
          return;
        }

        // Add to cart (delegated)
        if (e.target.closest('[data-fz-qa-atc]')) {
          self.addSelected();
        }
      }, true);

      window.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      }, true);

    },

    fetchProduct: function (handle) {
      if (this.cache[handle]) return Promise.resolve(this.cache[handle]);
      var self = this;
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (p) { self.cache[handle] = p; return p; });
    },

    openFor: function (handle) {
      var self = this;
      this.fetchProduct(handle).then(function (product) {
        if (!product || !product.variants) return;

        // Single-variant products: add straight to cart, no modal
        if (product.variants.length === 1) {
          CartDrawer.addToCart(product.variants[0].id, 1);
          return;
        }

        self.product = product;
        self.selected = {};
        var first = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].available) { first = product.variants[i]; break; }
        }
        if (!first) first = product.variants[0];
        product.options.forEach(function (opt, idx) {
          self.selected[idx + 1] = first['option' + (idx + 1)];
        });

        self.overlay.querySelector('[data-fz-qa-title]').textContent = product.title;
        var img = self.overlay.querySelector('[data-fz-qa-img]');
        img.src = product.featured_image ? product.featured_image + (product.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=160' : '';
        img.alt = product.title;
        self.overlay.querySelector('[data-fz-qa-view]').href = product.url;

        var html = '';
        product.options.forEach(function (opt, idx) {
          var pos = idx + 1;
          var optName = (opt && opt.name) ? opt.name : opt;
          var values = [];
          product.variants.forEach(function (v) {
            var val = v['option' + pos];
            if (val && values.indexOf(val) === -1) values.push(val);
          });
          html += '<div class="fz-qa-group" data-fz-qa-group>' +
            '<p class="fz-qa-opt-label">' + optName + ': <strong data-fz-qa-selected>' + self.selected[pos] + '</strong></p>' +
            '<div class="fz-qa-values">';
          values.forEach(function (val) {
            var pressed = self.selected[pos] === val;
            html += '<button type="button" class="fz-qa-val" data-pos="' + pos + '" data-value="' + val.replace(/"/g, '&quot;') + '" aria-pressed="' + pressed + '">' + val + '</button>';
          });
          html += '</div></div>';
        });
        self.overlay.querySelector('[data-fz-qa-options]').innerHTML = html;

        self.syncVariant();
        self.overlay.classList.add('is-open');
        self.overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    },

    findVariant: function () {
      if (!this.product) return null;
      var self = this;
      return this.product.variants.find(function (v) {
        for (var i = 1; i <= self.product.options.length; i++) {
          if (v['option' + i] !== self.selected[i]) return false;
        }
        return true;
      });
    },

    syncVariant: function () {
      var v = this.findVariant();
      var priceEl = this.overlay.querySelector('[data-fz-qa-price]');
      var atc = this.overlay.querySelector('[data-fz-qa-atc]');
      if (v) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var qaPct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
          priceEl.innerHTML = '<s style="color:rgba(0,0,0,.4);font-weight:500;font-size:.85em;margin-right:6px">$' + (v.compare_at_price / 100).toFixed(2) + '</s>$' + (v.price / 100).toFixed(2) +
            '<span style="display:inline-block;margin-left:6px;padding:2px 7px;border-radius:9999px;background:rgba(34,197,94,.12);color:#15803d;font-size:.72em;font-weight:700">-' + qaPct + '%</span>';
        } else {
          priceEl.textContent = '$' + (v.price / 100).toFixed(2);
        }
        atc.disabled = !v.available;
        atc.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      } else {
        atc.disabled = true;
        atc.textContent = 'Unavailable';
      }
      // Swap the preview image to the selected variant's photo
      var img = this.overlay.querySelector('[data-fz-qa-img]');
      var src = (v && v.featured_image && v.featured_image.src)
        ? v.featured_image.src
        : (this.product && this.product.featured_image ? this.product.featured_image : '');
      if (img && src) {
        var next = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=320';
        if (img.src !== next) img.src = next;
      }
    },

    addSelected: function () {
      var v = this.findVariant();
      if (!v || !v.available) return;
      var self = this;
      var atc = this.overlay.querySelector('[data-fz-qa-atc]');
      atc.disabled = true;
      atc.textContent = 'Adding…';
      CartDrawer.addToCart(v.id, 1).then(function () {
        self.close();
        atc.disabled = false;
        atc.textContent = 'Add to Cart';
      });
    },

    close: function () {
      if (!this.overlay) return;
      this.overlay.classList.remove('is-open');
      this.overlay.setAttribute('aria-hidden', 'true');
      // Only restore scroll if the cart drawer isn't open
      var drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer || drawer.classList.contains('translate-x-full')) {
        document.body.style.overflow = '';
      }
    }
  };

  /* ═══════════════════════════════════════════════════════
     RECENTLY VIEWED + POST-ATC COMPLETE ORDER
     ═══════════════════════════════════════════════════════ */
  var FurzzeeRecent = {
    KEY: 'fz_recent_handles_v1',
    MAX: 12,
    cache: {},

    read: function () {
      try {
        var raw = localStorage.getItem(this.KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list.filter(Boolean) : [];
      } catch (e) {
        return [];
      }
    },

    write: function (list) {
      try {
        localStorage.setItem(this.KEY, JSON.stringify(list.slice(0, this.MAX)));
      } catch (e) {}
    },

    track: function (handle) {
      if (!handle) return;
      var list = this.read().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      this.write(list);
    },

    trackFromPage: function () {
      var el = document.querySelector('[data-fz-recent-track-handle]');
      if (el) this.track(el.getAttribute('data-fz-recent-track-handle'));
      else if (window.meta && meta.product && meta.product.handle) this.track(meta.product.handle);
    },

    fetchProduct: function (handle) {
      var self = this;
      if (this.cache[handle]) return Promise.resolve(this.cache[handle]);
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p) self.cache[handle] = p;
          return p;
        })
        .catch(function () { return null; });
    },

    money: function (cents) {
      return '$' + (Number(cents) / 100).toFixed(2);
    },

    cardHtml: function (p) {
      if (!p || !p.available) return '';
      var images = p.images || [];
      var img = (p.featured_image || images[0] || '');
      if (img && typeof img === 'object') img = img.src || '';
      var hover = '';
      if (images.length > 1) {
        hover = typeof images[1] === 'string' ? images[1] : ((images[1] && images[1].src) || '');
        if (hover === img) hover = '';
      }
      var toCardSrc = function (url) {
        return String(url).replace(/(\.[^.\/?]+)(\?|$)/, '_600x$1$2');
      };
      var price = p.price_min != null ? p.price_min : p.price;
      var compare = p.compare_at_price_min || p.compare_at_price || 0;
      var onSale = compare > price;
      var pct = onSale ? Math.round((compare - price) / compare * 100) : 0;
      var priceHtml = onSale
        ? '<s class="fz-pcard__was">' + this.money(compare) + '</s><span>' + this.money(price) + '</span><span class="fz-pcard__pct">-' + pct + '%</span>'
        : '<span>' + this.money(price) + '</span>';
      return (
        '<article class="fz-pcard" data-fz-pcard data-product-handle="' + CartDrawer.escapeHtml(p.handle) + '">' +
          '<a href="/products/' + CartDrawer.escapeHtml(p.handle) + '" class="fz-pcard__link" aria-label="' + CartDrawer.escapeHtml(p.title) + '">' +
            '<div class="fz-pcard__media">' +
              (img ? '<img class="fz-pcard__img fz-pcard__img--primary" src="' + CartDrawer.escapeHtml(toCardSrc(img)) + '" alt="" width="600" height="600" loading="lazy">' : '') +
              (hover ? '<img class="fz-pcard__img fz-pcard__img--hover" src="' + CartDrawer.escapeHtml(toCardSrc(hover)) + '" alt="" width="600" height="600" loading="lazy" aria-hidden="true">' : '') +
              (p.available
                ? '<button type="button" class="fz-pcard__qa" data-fz-qa data-handle="' + CartDrawer.escapeHtml(p.handle) + '" aria-label="Quick add ' + CartDrawer.escapeHtml(p.title) + '">' +
                    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path stroke-linecap="round" d="M12 5v14M5 12h14"/></svg>' +
                    '<span class="fz-pcard__qa-text">Quick add</span></button>'
                : '') +
            '</div>' +
          '</a>' +
          '<div class="fz-pcard__meta">' +
            '<a href="/products/' + CartDrawer.escapeHtml(p.handle) + '" class="fz-pcard__info" tabindex="-1" aria-hidden="true">' +
              '<h3 class="fz-pcard__title">' + CartDrawer.escapeHtml(p.title) + '</h3>' +
              '<span class="fz-pcard__price">' + priceHtml + '</span>' +
            '</a>' +
            '<div class="fz-pcard__swatches fz-pcard__swatches--empty" aria-hidden="true"></div>' +
          '</div>' +
        '</article>'
      );
    },

    render: function () {
      var section = document.querySelector('[data-fz-recent]');
      var track = document.querySelector('[data-fz-recent-track]');
      if (!section || !track) return;
      var handles = this.read();
      var current = document.querySelector('[data-fz-recent-track-handle]');
      var currentHandle = current ? current.getAttribute('data-fz-recent-track-handle') : '';
      handles = handles.filter(function (h) { return h && h !== currentHandle; }).slice(0, 8);
      if (!handles.length) {
        section.hidden = true;
        return;
      }
      var self = this;
      Promise.all(handles.map(function (h) { return self.fetchProduct(h); })).then(function (products) {
        var html = products.map(function (p) { return self.cardHtml(p); }).join('');
        if (!html) {
          section.hidden = true;
          return;
        }
        track.innerHTML = html;
        section.hidden = false;
      });
    }
  };

  var FurzzeeCompleteOrder = {
    root: null,
    list: null,
    tierEl: null,
    addBtn: null,
    pool: [],
    selected: {},
    pendingCart: null,
    skipOpen: false,

    init: function () {
      this.root = document.querySelector('[data-fz-complete]');
      if (!this.root) return;
      this.list = this.root.querySelector('[data-fz-complete-list]');
      this.tierEl = this.root.querySelector('[data-fz-complete-tier]');
      this.addBtn = this.root.querySelector('[data-fz-complete-add]');
      var self = this;
      this.root.querySelectorAll('[data-fz-complete-skip]').forEach(function (el) {
        el.addEventListener('click', function () { self.finish(false); });
      });
      if (this.addBtn) {
        this.addBtn.addEventListener('click', function () { self.finish(true); });
      }
    },

    isToyOrCleaning: function (p) {
      var blob = ((p.type || '') + ' ' + (p.title || '') + ' ' + (p.handle || '') + ' ' + (p.tags || []).join(' ')).toLowerCase();
      if (/bed|mat|mattress|blanket|sofa|car.?seat/.test(blob) && !/toy|chew|puzzle|brush|scoop|cleaner|hair|leash|harness/.test(blob)) {
        return false;
      }
      return /toy|chew|puzzle|plush|brush|scoop|cleaner|hair|leash|harness|accessory|cleaning/.test(blob);
    },

    minPrice: function (p) {
      if (p.variants && p.variants.length) {
        return Math.min.apply(null, p.variants.map(function (v) {
          var price = v.price;
          if (typeof price === 'string' && price.indexOf('.') !== -1) price = Math.round(parseFloat(price) * 100);
          return Number(price) || 999999;
        }));
      }
      var price = p.price_min != null ? p.price_min : p.price;
      if (typeof price === 'string' && price.indexOf('.') !== -1) price = Math.round(parseFloat(price) * 100);
      return Number(price) || 999999;
    },

    firstAvailableVariant: function (p) {
      if (!p.variants) return null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available !== false) return p.variants[i];
      }
      return p.variants[0] || null;
    },

    offer: function (cart, opts) {
      var self = this;
      opts = opts || {};
      this.pendingCart = cart;
      this.skipOpen = !!opts.skipOpen;
      this.selected = {};
      if (!this.root || !this.list) {
        if (!this.skipOpen) CartDrawer.open();
        return Promise.resolve(cart);
      }

      // PDP "Complete the cozy" checkboxes still selected → already stacked; skip sheet
      var fbtExtras = (window.FurzzeeFBT && typeof window.FurzzeeFBT.getSelectedItems === 'function')
        ? window.FurzzeeFBT.getSelectedItems()
        : [];
      if (fbtExtras.length > 0) {
        if (typeof window.FurzzeeFBT.clearSelected === 'function') window.FurzzeeFBT.clearSelected();
        if (!this.skipOpen) CartDrawer.open();
        return Promise.resolve(cart);
      }

      var state = getBundleProgress(cart.item_count || 0);
      if (this.tierEl) {
        if (state.next) {
          var need = state.next.min - (cart.item_count || 0);
          this.tierEl.hidden = false;
          this.tierEl.innerHTML = 'Add <span>' + need + ' more</span> to unlock <span>' + state.next.pct + '% off</span> at checkout.';
        } else {
          this.tierEl.hidden = true;
        }
      }

      this.list.innerHTML = '<p class="fz-complete__loading">Finding great pairings…</p>';

      var inCart = {};
      (cart.items || []).forEach(function (it) {
        if (it.product_id) inCart[String(it.product_id)] = true;
        if (it.handle) inCart[it.handle] = true;
      });

      return Promise.all([
        fetch('/collections/toys-enrichment/products.json?limit=50', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return {}; }),
        fetch('/collections/cleaning-kit/products.json?limit=50', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return {}; })
      ]).then(function (results) {
        var pool = [];
        ;[results[0], results[1]].forEach(function (data) {
          (data.products || []).forEach(function (p) {
            p.type = p.product_type || p.type || '';
            if (inCart[String(p.id)] || inCart[p.handle]) return;
            if (!self.isToyOrCleaning(p)) return;
            if (self.minPrice(p) > 3900) return;
            var v = self.firstAvailableVariant(p);
            if (!v || v.available === false) return;
            // Shopify collection JSON prices are dollars as strings sometimes
            if (typeof v.price === 'string' && v.price.indexOf('.') !== -1) {
              v.price = Math.round(parseFloat(v.price) * 100);
            }
            pool.push({ product: p, variant: v });
          });
        });
        // Prefer recently viewed addons first
        var recent = FurzzeeRecent.read();
        pool.sort(function (a, b) {
          var ai = recent.indexOf(a.product.handle);
          var bi = recent.indexOf(b.product.handle);
          if (ai === -1) ai = 999;
          if (bi === -1) bi = 999;
          return ai - bi;
        });
        self.pool = pool.slice(0, 3);
        // Nothing left to offer (already in cart / no pool) → go straight to cart
        if (!self.pool.length) {
          if (!self.skipOpen) CartDrawer.open();
          return cart;
        }
        self.renderList();
        self.open();
        return cart;
      });
    },

    renderList: function () {
      var self = this;
      if (!this.pool.length) {
        this.list.innerHTML = '<p class="fz-complete__loading">No extras available right now. Continue to bag.</p>';
        if (this.addBtn) this.addBtn.disabled = true;
        return;
      }
      this.list.innerHTML = this.pool.map(function (row, idx) {
        var p = row.product;
        var v = row.variant;
        var img = (p.images && p.images[0]) || p.featured_image || '';
        if (img && typeof img === 'object') img = img.src || '';
        return (
          '<label class="fz-complete__item" data-fz-complete-item data-idx="' + idx + '">' +
            '<input type="checkbox" class="fz-complete__check" data-fz-complete-check data-idx="' + idx + '">' +
            '<img src="' + CartDrawer.escapeHtml(String(img)) + '" alt="" width="64" height="64" loading="lazy">' +
            '<span>' +
              '<p class="fz-complete__name">' + CartDrawer.escapeHtml(p.title) + '</p>' +
              '<p class="fz-complete__price">' + CartDrawer.formatMoney(v.price) + '</p>' +
              '<span class="fz-complete__badge">Optional</span>' +
            '</span>' +
          '</label>'
        );
      }).join('');

      this.list.querySelectorAll('[data-fz-complete-check]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          var idx = parseInt(cb.getAttribute('data-idx'), 10);
          var item = cb.closest('[data-fz-complete-item]');
          if (cb.checked) self.selected[idx] = true;
          else delete self.selected[idx];
          if (item) item.classList.toggle('is-on', cb.checked);
          if (self.addBtn) self.addBtn.disabled = Object.keys(self.selected).length === 0;
        });
      });
      if (this.addBtn) this.addBtn.disabled = true;
    },

    open: function () {
      if (!this.root) return;
      this.root.classList.add('is-open');
      this.root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('fz-complete-open');
    },

    close: function () {
      if (!this.root) return;
      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('fz-complete-open');
    },

    finish: function (withSelected) {
      var self = this;
      var items = [];
      if (withSelected) {
        Object.keys(this.selected).forEach(function (k) {
          var row = self.pool[parseInt(k, 10)];
          if (row && row.variant) items.push({ id: row.variant.id, quantity: 1 });
        });
      }
      this.close();
      if (items.length) {
        CartDrawer.addItems(items, self.skipOpen, { skipComplete: true }).then(function () {
          if (!self.skipOpen) CartDrawer.open();
        });
      } else if (!this.skipOpen) {
        CartDrawer.open();
      }
    }
  };

  /* ═══════════════════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════════════════ */
  function init() {
    refreshStaleProductSection().then(function () {
      initAnnouncementBar();
      initMobileMenu();
      initCarousels();
      initProductGallery();
      initAccordions();
      CartDrawer.init();
      QuickAdd.init();
      initStickyAtc();
      FurzzeeFBT.init();
      FurzzeeCompleteOrder.init();
      FurzzeeRecent.trackFromPage();
      FurzzeeRecent.render();
      initVariantSelection();
      initNewsletterOffer();
      initSearch();
      initScrollReveal();
      initScrollToTop();
      initTrackOrderForm();
      initTrackOrderLinks();
      initTrack123Fallback();
      initPolicyBrandSanitizer();
      initProductDescSanitize();
      initCollectionFilters();
      initProductCardSwatches();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.FurzzeeCartDrawer = CartDrawer;
  window.FurzzeeFBT = FurzzeeFBT;
  window.FurzzeeRecent = FurzzeeRecent;
  window.FurzzeeCompleteOrder = FurzzeeCompleteOrder;
})();
